import Encoding from "encoding-japanese";
import _ from 'lodash';

import SearchGuestsModalView from "./searchGuestsModal.html";
import ConfigGuestModalView from "./configGuestModal.html";
import SearchGroupModalView from "./searchGroupModal.html";
import AssignIdentifierModalView from "./assignIdentifierModal.html";
import AssignZoneModalView from "./assignZone.html";
import AssignParkingsModalView from "./assignParkings.html";
import AssignAccreditationModalView from "./assignAccreditation.html";
import AssignActsModalView from "./assignActs.html";
import AssignAnnexesModalView from "./assignAnnexes.html";
import AssignTagsModalView from "../../tags/AssignTagsModal.html";
import AddNewPersonModalView from "./addNewPersonModal.html";
import AddNewParkingModalView from "../parkings/addNewParkingModal.html";
import AddNewZoneModalView from "./addNewZone.html";
import GuestNotesModalView from "./guestNotesModal.html";
import GuestSpaceZonesModalView from "./guestSpaceZonesModal.html";
import GuestVehiclesModalView from "./guestVehiclesModal.html";
import AssignCompanionsLimitModalView from "./assignCompanionsLimit.html";
import NotificationsModalMailInfoView from "../../notifications/NotificationsModalMailInfo.html";
import AddGuestModalView from "./addGuestModal.html";

angular.module("events")
    .directive("repeatEnd", ["$timeout", function ($timeout) {
        return {
            restrict: "A",
            link: function (scope: angular.IScope, element, attrs) {
                if ((scope as any).$last) {
                    $timeout(function () {
                        scope.$eval(attrs.repeatEnd);
                    });
                }
            }
        };
    }])

    .directive("focus", ["$timeout", function ($timeout) {
        return {
            scope: {
                trigger: '@focus'
            },
            link: function (scope, element) {
                scope.$watch('trigger', function (value) {
                    if (value === "true") {
                        $timeout(function () {
                            const input = element[0] as HTMLInputElement;
                            input.focus();
                            input.setSelectionRange(0, input.value.length);
                        });
                    }
                });
            }
        };
    }])

    .controller("EventsGuestsListCtrl", ['event', 'notificationService', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', '$http', '$window', '$sce', 'generateDocumentService', 'datasetsService','eventService', 'logService',
        function (event, notificationService, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, $http, $window, $sce, generateDocumentService, datasetsService, eventService, logService) {

            $scope.switchToNewView = function() {
                localStorage.setItem('guestListView', 'new');
                $state.go('events.edit.guests.list', {
                    id: $stateParams.id,
                    menu_item_id: $stateParams.menu_item_id
                });
            };

            var viewPref = localStorage.getItem('guestListView');
            if (viewPref === 'new') {
                $state.go('events.edit.guests.list', {
                    id: $stateParams.id,
                    menu_item_id: $stateParams.menu_item_id
                });
                return;
            }

            $scope.showAdvanceSearch = false;
            $scope.showComunications = true;
            $scope.showAttachments = false;
            $scope.incidentMessage = false;

            //opciones de paginacion
            $scope.paginationOptions = {
                pageSize: 250,
                currentPage: 0,
                numPages: 0,
                total: 0,
                pageStart: 0,
                pageEnd: 0,
                pageArray: []
            };

            $scope.search = {
                name: "",
                hasSearched: false,
                hasFilteredGroups: false,
                _sortBy: "name",
                pigs: [],
                send_status: null,
                accreditions_ids: null,
                parkings_ids: null,
                document_sent_id: null,
                zones: null,
                comunication: "",
                attachments: null,
                communicationStatus: "unsent",
                //checkIn
                checkInFilter: false,
                checkInArrived: true,
                checkInAnyDate: true,
                checkInDate: event.date_from,

            };

            $scope.showGroupByGroups = false;

            // Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_GUESTS_WRITE");
            $scope.allowUserRead = LoginService.permissionExist("USERS_READ");
            $scope.allowImport = LoginService.permissionExist("PERSONS_IMPORT");
            $scope.allowUpdateImport = LoginService.permissionExist("PERSONS_UPDATE_IMPORT");

            if (!Array.isArray($scope.$parent.menusItems)) {
                $state.go("events.edit", {id: $stateParams.id});
                return;
            }
            let results = $scope.$parent.menusItems.filter(m => m.id === parseInt($stateParams.menu_item_id, 10));
            if (results.length > 0) {
                $scope.allowWrite &&= results[0].editable;
                $scope.allowImport &&= results[0].editable;
            } else {
                $scope.allowWrite = false;
                $scope.allowImport = false;
            }

            // Traducciones que se repiten mucho
            $scope.send_status_unsent = $filter('translate')('events.guests.send_status_unsent');
            $scope.send_status_print = $filter('translate')('events.guests.send_status_print');
            $scope.send_status_mail = $filter('translate')('events.guests.send_status_mail');
            $scope.send_status_inscription = $filter('translate')('events.guests.send_status_inscription');
            $scope.pending = $filter('translate')('events.guests.pending');
            $scope.parking_pending = $filter('translate')('events.guests.parking_pending');
            $scope.pending_approval = $filter('translate')('events.guests.pending_approval');
            $scope.confirmed = $filter('translate')('events.guests.confirmed');
            $scope.rejected = $filter('translate')('events.guests.rejected');
            $scope.delegated = $filter('translate')('events.guests.delegated');
            $scope.manage_delegate = $filter('translate')('events.guests.manage_delegate');
            $scope.guests_translate = $filter('translate')('events.guests.guests');
            $scope.companion_nominal = $filter('translate')('events.guests.nominals');
            $scope.companion_not_nominal = $filter('translate')('events.guests.not_nominals');

            $scope.api_url = (window as any).CONFIG.api_url;

            $rootScope.title = $filter('translate')('events.title') + " - " + $filter('translate')('events.guests.guests');

            $rootScope.breadcrumb = [
                {title: $filter('translate')('events.title'), url: "events.list"},
                {title: event.name, url: "events.edit({ id: " + event.id + " })"},
                {title: $filter('translate')('events.guests.guests')}
            ];

            $scope.companion = false;
            $scope.addresses = [];
            $scope.guestsId = [];
            $scope.invitedGuests = [];
            $scope.invitedGuestsGroupByGroups = [];
            $scope.checkboxSimpleOptions = [];
            $scope.showParkingColumn = false;
            $scope.totalColumns = 7;
            $scope.documentsForGuests = [];
            $scope.accreditationsList = [];
            $scope.inscription_form_id = 0;

            $scope.sendStatusList = [
                {text: $scope.send_status_unsent, value: 'unsent', checked: false},
                {text: $filter('translate')('events.guests.send_status_print'), value: 'print', checked: false},
                {text: $filter('translate')('events.guests.send_status_mail'), value: 'mail', checked: false},
                {
                    text: $filter('translate')('events.guests.send_status_inscription'),
                    value: 'inscription',
                    checked: false
                }
            ];

            $scope.confirmationStatusList = [

                { text: $scope.pending, value: 'pending',     checked: $stateParams.status === 'pending'},
                { text: $scope.rejected, value: 'rejected',   checked: $stateParams.status === 'rejected'},
                { text: $scope.confirmed, value: 'confirmed', checked: $stateParams.status === 'confirmed'},
                { text: $scope.delegated, value: 'delegated', checked: $stateParams.status === 'delegated'},
                {
                    text: $scope.pending_approval,
                    value: 'pending_approval',
                    checked: $stateParams.status === 'pending_approval'
                },
                {
                    text: $scope.manage_delegate,
                    value: 'manage_delegate',
                    checked: $stateParams.status === 'manage_delegate'
                }

            ];

            $scope.use_rfid_access_control = event.use_rfid_access_control;

            function isDefinedAndNotNull(val) {
                return angular.isDefined(val) && val !== null;
            }

            function isDefinedAndNotNullOrEmpty(val) {
                return angular.isDefined(val) && val !== null && val !== "";
            }

            let optionsPi = {entity_type: "persons"};
            
            Restangular.all('InformationsGroups').getList(optionsPi).then(function (personsInformationGroups) {
                $scope.personsInformationGroups = personsInformationGroups;
                angular.forEach($scope.personsInformationGroups, function (pig) {
                    if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
                });
                $scope.checkboxSimpleOptions = [
                    {option: null, label: $filter('translate')('informations.all'), checked: true},
                    {option: true, label: $filter('translate')('events.staff.yes'), checked: false},
                    {option: false, label: $filter('translate')('events.staff.no'), checked: false}
                ];
            });

            //obtenemos el identificador del inscription_form. (ahora sólo hay uno, hay que comprobar que pasa si hay más de uno)
            var params = {
                event_id: $stateParams.id
            };

            Restangular.all("InscriptionsForms").customGET("CustomGetInscriptionFromEvent", params).then(function (results) {
                $scope.inscription_form_id = results;
            });

            $scope.togleIncidents = function () {
                $scope.auxShowIncidents = $scope.showIncidents;
            };

            $scope.app_enabled = false;

            Restangular.one('Companies', $rootScope.company_id).get().then(function (results) {
                $scope.app_enabled = results.public_guest_app_enabled;
            }, function (response) {
                $scope.errorMessage = response.message;
            });

            Restangular.all('EventsGuests').customGET('GetGuestsPageInit', {event_id: params.event_id}).then(function (result) {
                // Restangular envuelve la respuesta entera y las arrays anidadas como colecciones Restangular;
                // si las dejamos así, .push() y _.map() comportan diferente y AngularJS no detecta cambios.
                // Convertimos a objetos/arrays planos con .plain().
                var data = result && result.plain ? result.plain() : result;

                $scope.accreditationsList = (data.accreditations || []).slice();
                $scope.accreditationsList.push({id: 0, name: $filter('translate')('events.guests.no_accreditation')});

                var parkings = data.parkings || [];
                if (parkings.length > 0) {
                    $scope.parkingsList = parkings.slice();
                    $scope.parkingsList.push({id: 0, name: $filter('translate')('events.guests.no_parking')});
                    $scope.showParkingColumn = true;
                    $scope.totalColumns = 8;
                }

                $scope.zonesList = _.map(data.zoneOptions || [], function (zone) {
                    return { id: zone, name: zone };
                });
                $scope.zonesList.push({ id: 'no_zone', name: $filter('translate')('events.guests.no_zone') });

                $scope.spaceList = (data.spaces || []).slice();
                $scope.spaceList.push({ id: 0, name: $filter('translate')('events.guests.no_space'), zones: [] });

                $scope.documentsForGuests = data.documents || [];
                $scope.selectComunications = data.communications || [];
            });

            $scope.selectAttachment = [
                {key: "att_parking_mail", text: $filter('translate')('events.guests.no_att_parking_mail')},
                {key: "att_menu_mail", text: $filter('translate')('events.guests.no_att_menu_mail')},
                {key: "att_acreditation", text: $filter('translate')('events.guests.no_att_acreditation')},
                {key: "att_program", text: $filter('translate')('events.guests.no_att_program')},
                {key: "att_send_status", text: $filter('translate')('events.guests.no_att_send_status')}
            ];

            /* FILTROS */
            $scope.showIncidents = false;
            $scope.guestReferred = false;
            $scope.guestInformation = false;

            $scope.searchByTags = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AssignTagsModalView,
                    size: "ld",
                    controller: "tagsModalCtrl",
                    scope: $scope,
                    resolve: {

                        is_search: function () {
                            return true
                        },

                        selected_tags_ids: function () {
                            return $scope.tags != null ? $scope.tags.map(m => m.id) : [];
                        },
                        entity_type: function () {
                            return "persons";
                        },
                        entity_id: function () {
                            return null;
                        }

                    }
                });

                $modalInstance.result.then(function (tagIdList) {

                    $scope.tags = [];

                    if (tagIdList != null && tagIdList.length > 0) {

                        Restangular.all("Tags").customGET("TagsByIdList", { id_list: tagIdList }).then(function (results) {

                            $scope.tags = results;

                        });

                    }
                }, function () {
                });
            }

            $scope.searchGuests = function () {
                $scope.paginationOptions.currentPage = 0;
                $scope.loadGuests();
            };

            $scope.loadGroups = function () {
                Restangular.all('Groups').getList().then(function (results) {
                    $scope.groups = results;
                });
            };

            $scope.loadGuests = function () {
                $scope.search.hasSearched = true;
                let options: any = {
                    _pageSize: $scope.paginationOptions.pageSize,
                    _page: $scope.paginationOptions.currentPage,
                    event_id: $stateParams.id
                };

                // Comprobamos si hay incidencias o no
                Restangular.one('EventsGuests/ExistsIncidencesInPositions').get({event_id: params.event_id}).then(function (res) {
                    $scope.incidentMessage = res;
                });

                options.confirmation_status = _.chain($scope.confirmationStatusList)
                .filter(function (status) {
                    return status.checked;
                })
                .map(function (status) {
                    return status.value;
                })
                .value();

                if (typeof ($scope.search.send_status) !== "undefined" && $scope.search.send_status != null) options.send_status = [$scope.search.send_status];
                if (typeof ($scope.search.accreditions_ids) !== "undefined" && $scope.search.accreditions_ids != null) options.accreditions_ids = [$scope.search.accreditions_ids];
                if (typeof ($scope.search.parkings_ids) !== "undefined" && $scope.search.parkings_ids != null) options.parkings_ids = [$scope.search.parkings_ids];
                if (typeof ($scope.search.zones) !== "undefined" && $scope.search.zones != null) options.zones = [$scope.search.zones];
                if (typeof ($scope.search.document_sent_id) !== "undefined" && $scope.search.document_sent_id != null) options.document_sent_id = [$scope.search.document_sent_id];

                options.incidents = $scope.showIncidents;
                options.deferred = $scope.guestReferred;
                options.name = $scope.search.name;
                options.groups_ids = $scope.search.groups;
                options.comunication = $scope.search.comunication;
                options.communicationStatus = $scope.search.communicationStatus;
                options.event_space_id = $scope.search.space != null ? $scope.search.space.id : null;
                options.event_space_zone_id = $scope.search.event_space_zone_id;
                if ($scope.tags != null && $scope.tags.length > 0) { options.tags_ids = $scope.tags.map(m => m.id) }

                // check in 
                if ($scope.search.checkInFilter == true) {
                    options.checkInArrived = $scope.search.checkInArrived;
                    if ($scope.search.checkInAnyDate != true && typeof ($scope.search.checkInDate) !== "undefined" && $scope.search.checkInDate != null) options.checkInDate = $scope.search.checkInDate;
                }

                if (typeof ($scope.search.attachment) !== "undefined") {
                    var cont = 0;
                    angular.forEach($scope.search.attachment, function (item) {
                        cont = cont + 1;
                        if (cont == 1) {
                            options.attachment = item;
                        }
                    });
                };

                options.institution = $scope.search.institution;

                var pigs = "";
                for (var key in $scope.search.pigs) {

                    if (typeof $scope.search.pigs[key] != "undefined" && $scope.search.pigs[key] != "") {
                        if (typeof ($scope.search.pigs[key]) == "object") {
                            //estamos en el selector simple.
                            //if ($scope.search.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key].checked;
                            var infoFilter = $scope.personsInformationGroups.filter(function (el) {
                                return el.id == key;
                            });
                            if (infoFilter.length == 1) {
                                if (infoFilter[0].type == "datetime") {
                                    if ($scope.search.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.search.pigs[key]).toISOString();
                                } else if (infoFilter[0].type == "checkboxSimple") {
                                    if ($scope.search.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key].checked;
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key];
                                }
                            }
                        } else {
                            pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.search.pigs[key];
                        }
                    }

                }

                options.pigs = pigs;

                options.positions_ids = $scope.search.positions;
                options._sortBy = $scope.search._sortBy;

                if (options._sortBy == 'group') {
                    $scope.showGroupByGroups = true;
                    options._pageSize = 5000;
                    $scope.paginationOptions.pageSize = 5000;
                } else {
                    $scope.showGroupByGroups = false;
                }

                Restangular.all('EventsGuests').getList(options).then(function (guests) {
                    $scope.invitedGuests = guests;
                    $scope.items = new Array();
                    var items = new Array();
                    if ($scope.showGroupByGroups) {
                        //cargamos grupos
                        Restangular.all('Groups').getList().then(function (results) {

                            //sacamos grupos que es necesario pintar
                            var groupsIds = new Array();
                            angular.forEach(guests, function (guest) {
                                if (groupsIds.indexOf(guest.group_id) < 0) groupsIds.push(guest.group_id);
                            });

                            //generamos lista de grupos
                            function addParentGroup(allGroups, groups, group) {
                                if (group.FK_groups_groups_groups1 != null && group.FK_groups_groups_groups1.length > 0) {
                                    //Tiene algun padre.
                                    if (group.FK_groups_groups_groups1[0].parent_group_id != null) {
                                        var parent = $filter('filter')(allGroups, {id: group.FK_groups_groups_groups1[0].parent_group_id}, true)[0];
                                        //tenemos al padre.
                                        addParentGroup(results, groups, parent);

                                        //comprobamos si existe ya, para no añadirlo varias veces
                                        var foundGroups = $filter('filter')(groups, {id: parent.id}, true);
                                        if (foundGroups.length == 0) {
                                            groups.push(parent);
                                        }
                                    }
                                }
                            }

                            var groups = new Array();
                            angular.forEach(results, function (group) {
                                if (groupsIds.indexOf(group.id) >= 0) {

                                    //buscamos padres y los añadimos
                                    addParentGroup(results, groups, group);

                                    //añadimos actual
                                    groups.push(group);

                                }
                            });

                            $scope.groups = groups;

                            var level = 0;
                            var pushedGroups = new Array();
                            angular.forEach(groups, function (group) {

                                if (group.FK_groups_groups_groups1 == null || group.FK_groups_groups_groups1.length == 0) {
                                    //No tiene padre
                                    level = 0;
                                } else {
                                    //si el padre ya ha salido, pasamo level al del padre + 1
                                    var parentPushed = $filter('filter')(pushedGroups, {id: group.FK_groups_groups_groups1[0].parent_group_id}, true);
                                    if (parentPushed.length > 0) {
                                        level = parentPushed[0].level + 1;
                                    }
                                }

                                //añadimos grupo a lista final
                                group.text_color = invertColor(group.color);
                                group.type = "group";
                                group.level = level;
                                items.push(group);

                                //añadimos invitados del grupo
                                var groupGuests = $filter('filter')(guests, {
                                    group_id: group.id,
                                    referrer_person_id: null
                                }, true);
                                angular.forEach(groupGuests, function (guest) {
                                    guest.type = "guest";
                                    guest.level = level;
                                    items.push(guest);

                                    //los acompañantes de este se inluyen seguidamente
                                    var companions = $filter('filter')(guests, {referrer_person_id: guest.person_id}, true);
                                    angular.forEach(companions, function (companion) {
                                        companion.type = "guest";
                                        companion.level = level + 1;
                                        items.push(companion);
                                    });
                                });

                                pushedGroups.push(group);

                                level++;
                            });
                            $scope.items = items;
                        });

                    } else {
                        //Si la opcion de busqueda del nombre no esta vacia, buscaremos en todos los niveles, sin identificar si es acompañante o delegado en
                        if (options["name"] != "" || options["confirmation_status"] != "") {
                            $scope.items = guests;
                            $scope.items.forEach(function (row) {
                                if (row.referred_in != null) {
                                    row.referred_in = row.referred_in.replace('<br>', ' ');
                                }

                                row.type = "guest";
                                row.level = 0;
                                //Obtener el número real de acompañantes de un invitado
                                var companions = $filter('filter')(guests, {referrer_person_id: row.person_id}, true);
                                row.tot_companions = companions.length;
                                if (row.num_companions > companions.length) {
                                    row.tot_companions_not_nominal = row.num_companions - companions.length;
                                }
                                items.push(row);
                                $scope.namesColumnMailings = row.namesColumnMailings;
                            })
                            $scope.searchByName = true;
                        } else {
                            //añadimos invitados
                            let principalGuests = null;
                            if (typeof (options.attachment) == 'undefined' && ((options.comunication == '' || options.comunication == null) && options.event_space_id == null && options.accreditions_ids == null)) {
                                principalGuests = $filter('filter')(guests, {referrer_person_id: null}, true);
                            } else {
                                principalGuests = guests;
                            }
                            angular.forEach(principalGuests, function (guest) {
                                guest.type = "guest";
                                guest.level = 0;
                                //Obtener el número real de acompañantes de un invitado
                                var companions = $filter('filter')(guests, {referrer_person_id: guest.person_id}, true);
                                guest.tot_companions = companions.length;
                                if (guest.num_companions > companions.length) {
                                    guest.tot_companions_not_nominal = guest.num_companions - companions.length;
                                }
                                if (guest.referred_in != null) {
                                    guest.referred_in = guest.referred_in.replace('<br>', ' ');
                                }

                                items.push(guest);

                                if (typeof (options.attachment) == 'undefined' && ((options.comunication == '' || options.comunication == null) && options.event_space_id == null) && typeof (options.accreditions_ids) == 'undefined') { 
                                    angular.forEach(companions, function (companion) {
                                        companion.type = "guest";
                                        companion.level = 1;
                                        var g_companions = $filter('filter')(guests, {referrer_person_id: companion.person_id}, true);
                                        companion.tot_companions = g_companions.length;
                                        if (companion.num_companions > g_companions.length) {
                                            companion.tot_companions_not_nominal = companion.num_companions - g_companions.length;
                                        }
                                        if (companion.referred_in != null) {
                                            companion.referred_in = companion.referred_in.replace('<br>', ' ');
                                        }
                                        items.push(companion);
                                        if (companion.tot_companions > 0 && companion.referred_option == "delegated") {
                                            angular.forEach(g_companions, function (companion_sub) {
                                                companion_sub.type = "guest";
                                                companion_sub.level = 1;
                                                if (companion_sub.referred_in != null) {
                                                    companion_sub.referred_in = companion_sub.referred_in.replace('<br>', ' ');
                                                }
                                                items.push(companion_sub);
                                            });
                                        }
                                    });
                                }

                                $scope.namesColumnMailings = guest.namesColumnMailings;

                            });

                            $scope.items = items;
                        }
                    }

                    angular.forEach($scope.items, function(item) {
                        var map = {};
                        if (item.mailings_guests_list) {
                            angular.forEach(item.mailings_guests_list, function(row) {
                                if (!map[row.short_title]) map[row.short_title] = [];
                                map[row.short_title].push(row);
                            });
                        }
                        item._mailingsByCol = map;
                    });

                    //Paginacion
                    $scope.paginationOptions.total = guests.totalRows;
                    $scope.paginationOptions.numPages = Math.ceil($scope.paginationOptions.total / $scope.paginationOptions.pageSize);
                    $scope.paginationOptions.pageArray = _.range(parseInt($scope.paginationOptions.numPages));

                    if ($scope.paginationOptions.currentPage >= $scope.paginationOptions.numPages) {
                        $scope.paginationOptions.currentPage = $scope.paginationOptions.numPages;
                    }
                    $scope.paginationOptions.pageStart = ($scope.paginationOptions.currentPage * $scope.paginationOptions.pageSize) + 1;
                    $scope.paginationOptions.pageEnd = ($scope.paginationOptions.currentPage * $scope.paginationOptions.pageSize) + guests.length;
                    if ($scope.paginationOptions.pageStart > $scope.paginationOptions.total) $scope.paginationOptions.pageStart = 0;

                    if (!$scope.$$phase) {
                        $scope.$apply();
                    }

                });
            };

            $scope.clearform = function () {
                $scope.search = {
                    name: "",
                    hasSearched: false,
                    hasFilteredGroups: false,
                    _sortBy: "name",
                    pigs: [],
                    send_status: null,
                    accreditions_ids: null,
                    parkings_ids: null,
                    document_sent_id: null,
                    zones: null,
                    comunication: "",
                    attachments: null,
                    communicationStatus: "unsent",
                    //checkIn
                    checkInFilter: false,
                    checkInArrived: true,
                    checkInAnyDate: true,
                    checkInDate: event.date_from,
                    space: null, 
                    event_space_zone_id: null, 
                };
                $scope.paginationOptions = {
                    pageSize: 250,
                    currentPage: 0,
                    numPages: 0,
                    total: 0,
                    pageStart: 0,
                    pageEnd: 0,
                    pageArray: []
                };
                $scope.showIncidents = false;
                $scope.loadGuests();
            }

            $scope.changePage = function (page) {
                $("html, body").animate({scrollTop: $('#divGuestList').offset().top}, 300);
                $scope.paginationOptions.currentPage = page;
                $scope.loadGuests();
            };

            $scope.checkAll = function (selectedAll) {
                _.each($scope.invitedGuests, function (guest) {
                    guest.value = selectedAll ? guest.id : "";
                });
            };

            /* Sección guests_events */
            $scope.saveEventGuests = function () {
                $scope.eventGuestsContainer = {};
                $scope.eventGuestsContainer.event_id = $stateParams.id;
                $scope.eventGuestsContainer.events_guests = $scope.invitedGuests;

                Restangular.all('EventsGuests').post($scope.eventGuestsContainer).then(function (result) {
                    toastr.success($filter('translate')('events.edit_success'));
                    $state.go("events", {id: $stateParams.id});
                });
            };

            $scope.addGuestDialog = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddGuestModalView,
                    size: "lg",
                    controller: "AddGuestModalCtrl",
                    scope: $scope,
                    resolve: {
                        params: function () {
                            return {
                                event_id: event.id,
                                referrer_person_id: null,
                                is_delegate: false
                            }
                        }
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (data) {
                    toastr.success($filter('translate')('events.guests.action_success'));
                    $scope.loadGuests();
                    if (!$scope.$$phase) $scope.$apply();
                    $scope.$parent.loadInfo($stateParams.id);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            };

            $scope.searchMasiveDialog = function () {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchGuestsModalView,
                    size: "lg",
                    controller: "SearchGuestsModalCtrl",
                    scope: $scope,
                    resolve: {
                        options: function () {
                            return {
                                onGuestsAdded: function () {
                                    $scope.loadGuests();
                                    $scope.$parent.loadInfo($stateParams.id);
                                }
                            };
                        }
                    }
                });
                //Response del modal
                $modalInstance.result.then(function (data) {
                    $scope.loadGuests();
                    if (!$scope.$$phase) $scope.$apply();
                    $scope.$parent.loadInfo($stateParams.id);
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            }; //addPersonsPositionDialog

            $scope.deleteDialog = function (id, name, surname, send_status) {

                let allName = name + " " + surname;

                var message = $filter('translate')('events.guests.delete_confirmation') + " " + allName + "?";
                if (send_status !== 'unsent') {
                    message = $filter('translate')('events.guests.invitation_already_sent') + " (" + $filter('translate')('events.guests.send_status_' + send_status) + "). <br>" + message;
                }

                $scope.id = id;

                modalService.confirm({
                    title: $filter('translate')('events.guests.delete'),
                    message: message,
                    onAccept: function () {
                        Restangular.one('EventsGuests', id).remove().then(function () {
                            $scope.loadGuests();
                            toastr.success($filter('translate')('events.guests.delete_ok'));
                            $scope.$parent.loadInfo($stateParams.id);
                        }, function (response) {
                            alert("Error al borrar")
                        });
                    }
                });

            };

            /**
             * Popup de configuracion del invitado.
             * @param {guest} item - The guest.
             **/

            $scope.configDialog = function (item) {
                let $modalInstance = null;
                if ($rootScope.sizeLg) {
                    $modalInstance = $uibModal.open({
                        animation: true,
                        template: ConfigGuestModalView,
                        size: "lg-extra",
                        controller: "ConfigGuestsModalCtrl",
                        resolve: {
                            item: function () {
                                return item;
                            },
                            event: function () {
                                return event;
                            }
                        }
                    });
                } else {
                    $modalInstance = $uibModal.open({
                        animation: true,
                        template: ConfigGuestModalView,
                        controller: "ConfigGuestsModalCtrl",
                        resolve: {
                            item: function () {
                                return item;
                            },
                            event: function () {
                                return event;
                            }
                        }
                    });
                }

                //Response del modal
                $modalInstance.result.then(function (data) {
                    $scope.showIncidents = false;
                    $scope.loadGuests();
                    $scope.$parent.loadInfo($stateParams.id); //recalculamos
                    if (!$scope.$$phase) $scope.$apply();
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            };  //End configdialog

            let loadDocuments = function () {
                var optionsValues = {
                    codes: ["GUEST_LIST", "PROPOSAL_GUEST_LIST", "PROGRAM_ACTS", "GUEST_ACCREDITATION", "GUEST_LIST_ADDRESSES", "GUEST_PARKING", "INVITATION", "SEATING", "CERTIFICATES", "PROTOCOL_NOTES", "EVENT_MENU"]
                };
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'Documents/GetDocumentsByDocumentsType',
                    params: optionsValues
                }).then(function (results, status, headers, config) {
                    $scope.documentsTypesSpecifics = results.data.rows.map(function (item) {
                        return {
                            code: item.FK_documents_documents_types.code,
                            name: item.FK_documents_documents_types.name,
                            icon: item.FK_documents_documents_types.icon
                        }
                    }).filter(function (x, i, a) {
                        return a.findIndex(m => m.code === x.code) == i;
                    });
                });
            };

            loadDocuments();

            let generateDocumentPopup = function (code, event_guests_id) {
                var params = {
                    entity_type: "events",
                    entity_type_id: $stateParams.id,
                    event_guests_id: event_guests_id,
                    mail_account_id: event.mail_account_id,
                    mail_account_reply: event.reply_to,
                    documents: {codes: code}
                };
                generateDocumentService.documentNew({
                    params: params,
                    onAccept: function (data) {
                        angular.forEach(data, function (item) {
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'documentgenerator/Generate',
                                params: {
                                    document_id: item.document_id,
                                    event_id: $stateParams.id,
                                    event_guests_id: event_guests_id.toString(),
                                    order: item.url_params,
                                    outputType: 'pdf',
                                    type: item.type
                                }
                            }).then(function (result, status, headers, config) {
                                var url = (window as any).CONFIG.api_url + 'documentgenerator/download/' + result.data;
                                window.open(url, '_blank');
                            });
                        })
                       }
                    });
                   };

            $scope.newPrintDialog = function (code) {
                let event_guests_id = [];
                //miramos si dependiendo del codigo debe o no seleccionar personas.
                var type_result = "list_checked";
                if (code === "PROPOSAL_GUEST_LIST" || code === "GUEST_LIST") type_result = "";

                if (type_result === "list_checked") {
                    var guests = _.chain($scope.invitedGuests)
                        .filter(function (option) {
                            return angular.isDefined(option.value) && option.value != "";
                        })
                        .value();

                    if (guests.length === 0) {
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('events.guests.select_persons'),
                            onAccept: function () {
                            }
                        });
                    } else {
                        if (code == "PROGRAM_ACTS" && guests.length > 1) {
                            modalService.message({
                                title: "Error",
                                message: $filter('translate')('events.guests.max_guests_selection'),
                                onAccept: function () {
                                }
                            });
                        } else {
                            event_guests_id = _.map(guests, function (guest) {
                                return guest.id;
                            });

                            if (code == "GUEST_ACCREDITATION" || code == "INVITATION" || code == "GUEST_PARKING" || code == "GUEST_LIST_ADDRESSES") {
                                //preguntar si le cambia al invitado el estado de envio de las partes que sean.
                                var message = $filter('translate')('events.guests.mark_as_sent_invitation');
                                if (code == "GUEST_PARKING") message = $filter('translate')('events.guests.mark_as_sent_parking');
                                if (code == "GUEST_ACCREDITATION") message = $filter('translate')('events.guests.mark_as_sent_accreditation')
                                modalService.confirm({
                                    title: "",
                                    message: message,
                                    onAccept: function () {
                                        generateDocumentPopup(code, event_guests_id); //Popup de documentación

                                        //1) Se actualiza el estado de envio.
                                        var url = "ChangeStatus";
                                        if (code == "GUEST_PARKING") url = "ChangeStatusParking";
                                        if (code == "GUEST_ACCREDITATION") url = "ChangeStatusAccreditation";
                                        var params = {event_guests_id: event_guests_id, send_status: "print"};
                                        $http({
                                            method: 'post',
                                            url: (window as any).CONFIG.api_url + 'EventsGuests/' + url,
                                            params: params
                                        }).then(function (results, status, headers, config) {
                                            $scope.loadGuests();
                                        });
                                    },
                                    onCancel: function () {
                                        generateDocumentPopup(code, event_guests_id);
                                    }
                                });

                            } else {
                                generateDocumentPopup(code, event_guests_id);
                            }
                        }
                    }
                } else {
                    generateDocumentPopup(code, []);
                }
            }

            $scope.printCSV = function () {
                window.open((window as any).CONFIG.api_url + 'documentgenerator/GetCsvGuests/' + $stateParams.id, '_blank');
            };

            $scope.searchGroup = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchGroupModalView,
                    size: "lg",
                    controller: "SearchGroupModalCtrl",
                    resolve: {
                        preselect: function () {
                            return true;  //para preseleccionar los grupos ya buscados
                        },
                        event_id: function () {
                            return $stateParams.id;
                        },
                        is_filter: function () {
                            return false;
                        },
                        listGroupsIds: function () {
                            return [];
                        },
                        listPositionsIds: function () {
                            return [];
                        }
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (groups) {
                    var postGroups = { event_id: $stateParams.id, list: null, listPositions: groups.listPositions };

                    if (typeof (groups) != 'undefined' && groups != null && groups.listPositions.length > 0) {

                        //Peticion al api para que me devuelva las personas que estan en esos grupos.
                        Restangular.all('EventsGuests/AddGuestFromGroups').post(postGroups).then(function (success) {
                            $scope.loadGuests();
                        });
                    }

                    $scope.loadGuests();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });
            };

            $scope.getContrastYIQ = function (hexcolor) {
                if (hexcolor != null) {
                    if (hexcolor[0] === "#") {
                        hexcolor = hexcolor.substring(1, hexcolor.length);
                    }
                    var r = parseInt(hexcolor.substr(0, 2), 16);
                    var g = parseInt(hexcolor.substr(2, 2), 16);
                    var b = parseInt(hexcolor.substr(4, 2), 16);
                    var yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
                    return (yiq >= 128) ? {color: '#000000'} : {color: '#FFFFFF'};
                } else {
                    return "";
                }
            };

            $scope.assignIdentifier = function (event_guest, index) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: AssignIdentifierModalView,
                    size: "md",
                    controller: "AssignIdentifierModalCtrl",
                    resolve: {
                        event_guest: function () {
                            return event_guest;
                        }
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (data) {

                    Restangular.all("EventsGuests").customPOST({}, "CustomSaveIdentifier", data).then(function (results) {

                        if (results != true) {

                            modalService.confirm({
                                title: $filter('translate')('events.guests.warning'),
                                message: $filter('translate')('events.guests.identifier_already_used') + "?",
                                onAccept: function () {
                                    data.forceSaved = true;
                                    Restangular.all("EventsGuests").customPOST({}, "CustomSaveIdentifier", data).then(function (results) {

                                        toastr.success($filter('translate')('events.guests.identifier_saved'));
                                        event_guest.identify_id = 0;
                                        //$scope.invitedGuests[index] = event_guest;

                                        if (!$scope.$$phase) $scope.$apply();

                                    });

                                }
                            });
                        } else {
                            event_guest.identify_id = 0;
                            //$scope.invitedGuests[index] = event_guest;
                            $scope.$parent.loadInfo($stateParams.id); //recalculamos*/
                            if (!$scope.$$phase) $scope.$apply();
                        }
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();
                });

            };

            $scope.sendProgram = function (code) {
                var personIds = _.chain($scope.invitedGuests)
                    .filter(function (guest) {
                        return angular.isDefined(guest.value) && guest.value != "";
                    })
                    .map(function (guest) {
                        return guest.person_id;
                    })
                    .value();
                if (personIds.length === 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.select_program_persons'),
                        onAccept: function () {
                        }
                    });
                } else if (event.mail_account_id === null || event.mail_account_id === 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.select_mail_from_address'),
                        onAccept: function () {
                        }
                    });
                } else {
                    modalService.confirm({
                        title: $filter('translate')('events.guests.warning'),
                        message: $filter('translate')('events.guests.program_send_mail'),
                        onAccept: function () {
                            let params: any = {
                                event_id: $stateParams.id,
                                code: code,
                                type_document: 'pdf',
                                type_result: 'list',
                                id: "",
                                event_guests_id: ""
                            };
                            $http({
                                method: 'get',
                                url: (window as any).CONFIG.api_url + 'EventsGuests / GetProgramInfo',
                                params: {event_id: $stateParams.id}
                            }).success(function (results, status, headers, config) {
                                if (results) {
                                    params = {person_ids: personIds, event_id: $stateParams.id};
                                    $http({
                                        method: 'post',
                                        url: (window as any).CONFIG.api_url + 'EventsGuests/SendProgram',
                                        params: params
                                    }).success(function (results, status, headers, config) {
                                        if (results.success) {
                                            toastr.success($filter('translate')('events.work_team.email_sent_success'));
                                        } else {
                                            modalService.message({
                                                title: $filter('translate')('events.guests.fail_send_email'),
                                                message: results.message,
                                                onAccept: function () {
                                                }
                                            });
                                        }

                                    });
                                } else {
                                    //Primero comprobamos si existe algo en el programa:
                                    $http({
                                        method: 'get',
                                        url: (window as any).CONFIG.api_url + 'EventsGuests/ProgramExist',
                                        params: {event_id: $stateParams.id}
                                    }).success(function (resultsProgramExist, status, headers, config) {
                                        if (resultsProgramExist) {
                                            var paramsNew = {
                                                entity_type: "events",
                                                entity_type_id: $stateParams.id,
                                                documents: {codes: code}
                                            };
                                            generateDocumentService.documentNew({
                                                params: paramsNew,
                                                onAccept: function (data) {
                                                    params = {
                                                        person_ids: personIds,
                                                        event_id: $stateParams.id,
                                                        document_id: data.document_id
                                                    };
                                                    $http({
                                                        method: 'post',
                                                        url: (window as any).CONFIG.api_url + 'EventsGuests/SendProgram',
                                                        params: params
                                                    }).success(function (results, status, headers, config) {
                                                        if (results.success) {
                                                            toastr.success($filter('translate')('events.work_team.email_sent_success'));
                                                        } else {
                                                            modalService.message({
                                                                title: $filter('translate')('events.guests.fail_send_email'),
                                                                message: results.message,
                                                                onAccept: function () {
                                                                }
                                                            });
                                                        }
                                                    });
                                                },
                                                onError: function (response) {
                                                    let errorMessage = response.message;
                                                    toastr.error(errorMessage);
                                                }
                                            });
                                        } else {
                                            modalService.message({
                                                title: $filter('translate')('events.guests.not_program_defined_title'),
                                                message: $filter('translate')('events.guests.not_program_defined'),
                                                onAccept: function () {
                                                }
                                            });
                                        }

                                    });
                                }
                            });
                        }
                    });
                }
            };

            /**
             * ACCIONES
             **/
            $scope.AssociateZone = function () {
                var guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignZoneModalView,
                        size: "lg",
                        controller: "assignZoneMassiveModalCtrl",
                        resolve: {
                            options: {
                                only_one: false
                            }
                        }
                    });
                    //Response del modal
                    $modalInstance.result.then(function (option) {

                        var params = {
                            event_guests_ids: guestsIds,
                            zone: option.zone,
                            companions_zone: option.companions_zone
                        };

                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveZones',
                            params: params
                        }).then(function (results, status, headers, config) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                            $scope.searchGuests();
                        });

                    });
                }
            };

            $scope.AssociateParking = function (type) {
                var guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {

                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignParkingsModalView,
                        size: "lg",
                        controller: "assignParkingMassiveModalCtrl",
                        resolve: {
                            options: {},
                            event: function () {
                                return event;
                            }
                        }
                    });

                    // Response del modal
                    $modalInstance.result.then(function (options) {

                        Restangular.all("EventsGuests").customPOST(guestsIds, "SetMassiveParkings", { value: options.parking_id, allow_parking: options.allow_parking, max_vehicles: options.max_vehicles, custom_parking_config: options.custom_parking_config }).then(function (results) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                            $scope.loadGuests();
                        })

                    });
                    
                }
            };

            $scope.massiveAsignmentAccreditation = function (type) {
                var guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                   let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignAccreditationModalView,
                        // size: "lg",
                        controller: "assignAccreditationMassiveModalCtrl",
                        resolve: {
                            options: function () {
                                return {
                                    event_id: event.id
                                }
                            }
                        }
                   });

                    //Response del modal
                    $modalInstance.result.then(function (option) {

                        var params = { event_guests_ids: guestsIds, value: option.event_guest_accreditation_id };

                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveAccreditions',
                            params: params
                        }).then(function (results, status, headers, config) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                            //actualizamos datos de invitados
                            angular.forEach($scope.invitedGuests, function (guest) {
                                if (guestsIds.indexOf(guest.id) >= 0) {
                                    guest.event_guest_accreditation_id = option.event_guest_accreditation_id;
                                }
                            });

                            $scope.loadGuests();

                        });

                    });
                }
            };

            $scope.filterGroups = function () {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SearchGroupModalView,
                    size: "lg",
                    controller: "SearchGroupModalCtrl",
                    resolve: {
                        preselect: function () {
                            return true;
                        },
                        event_id: function () {
                            return $stateParams.id;
                        },
                        is_filter: function () {
                            return true;
                        },
                        listGroupsIds: function () {
                            return $scope.search.groups;
                        },
                        listPositionsIds: function () {
                            return $scope.search.positions;
                        }
                    }
                });

                //Response del modal
                $modalInstance.result.then(function (groups) {
                    $scope.search.hasFilteredGroups = groups.ids.length > 0;
                    $scope.search.groups_names = groups.ids.length + " " + $filter('translate')('guest.groups') + ". " + groups.listPositions.length + " " + $filter('translate')('guest.position');
                    /* $scope.search.groups_names = _.chain(groups.groups)
                         .filter(function (group) {
                             return _.some(groups.ids, function (id) {
                                 return id === group.id;
                             });
                         })
                         .reduce(function (memo, group) { return memo + group.name + "\n"; }, "")
                         .value();*/
                    $scope.search.groups = groups.ids;
                    $scope.search.positions = groups.listPositions;

                }, function () {

                    console.info('Modal dismissed at: ' + new Date());
                    if (!$scope.$$phase) $scope.$apply();

                });
            };

            $scope.unfilterGroups = function () {
                $scope.search.groups = [];
                $scope.search.positions = [];
                $scope.search.hasFilteredGroups = false;
            };

            $scope.MassiveRemove = function () {
                var persons = _.chain($scope.invitedGuests)
                    .filter(function (guest) {
                        return angular.isDefined(guest.value) && guest.value != "";
                    })
                    .value();

                var is_invited = _.some(persons, function (person) {
                    return person.send_status != 'unsent';
                });
                var guest_ids = _.map(persons, function (person) {
                    return person.id;
                });

                var deleteItems = {event_id: $stateParams.id, list: guest_ids}
                var delete_message = "";
                if (is_invited) delete_message = $filter('translate')('events.guests.invitation_already_sent_massive') + "<br>";
                delete_message += $filter('translate')('events.guests.delete_confirm_massive');
                modalService.confirm({
                    title: $filter('translate')('events.guests.warning'),
                    message: delete_message,
                    onAccept: function () {
                        Restangular.all('EventsGuests/DeleteMassive').post(deleteItems).then(function (results, status, headers, config) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                            $scope.loadGuests();
                        });
                    }
                });
            };

            $scope.SetCompanionsLimit = function () {
                var guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignCompanionsLimitModalView,
                        size: "md",
                        controller: "assignCompanionsLimitModalCtrl",
                        resolve: {
                            event: function () {
                                return event;
                            },
                            options: {}
                        }
                    });

                    // Response del modal
                    $modalInstance.result.then(function (option) {

                        var params = { event_guests_ids: guestsIds, value: option.max_companions_allowed, is_companion_allowed: option.is_companions_allowed };

                        $http({
                            method: 'post',
                            url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveCompanions',
                            params: params
                        }).then(function (results, status, headers, config) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                        });

                    });
                }
            };

            $scope.massiveAsignmentActs = function (type) {
                var guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignActsModalView,
                        size: "lg",
                        controller: "assignActsMassiveModalCtrl",
                        resolve: {
                            event_id: function () {
                                return $stateParams.id;
                            },
                        }
                    });

                    // Response del modal
                    $modalInstance.result.then(function (eventsProgramsActSelected) {
                        //Seleccionamos los actos a los que invitado esta invitado.
                        let event_acts_ids = [];
                        angular.forEach(eventsProgramsActSelected, function (item, idx) {
                            if (item) event_acts_ids.push(idx);
                        });

                        if (event_acts_ids.length > 0) {
                            var epag = {
                                event_acts_ids: event_acts_ids,
                                guests_id: guestsIds,
                                event_id: event.id
                            }
                            //Guardamos los actos
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'EventsGuests/SetMassiveActsGuest',
                                data: epag,
                            }).then(function (resultsImage, status, headers, config) {
                                toastr.success($filter('translate')('events.guests.action_success'));
                            });
                        }
                    });
                }
            };

            $scope.assignAnnexes = function (type) {
                var guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignAnnexesModalView,
                        size: "lg",
                        controller: "assignAnnexesModalCtrl",
                        resolve: {
                            event_id: function () {
                                return $stateParams.id;
                            },
                        }
                    });
                    //Response del modal
                    $modalInstance.result.then(function (eventsAnnexesSelected) {
                        //Seleccionamos los actos a los que invitado esta invitado.
                        let events_annexes_ids = [];
                        angular.forEach(eventsAnnexesSelected, function (item, idx) {
                            if (item) events_annexes_ids.push(idx);
                        });

                        if (events_annexes_ids.length > 0) {
                            var annexes = {
                                guests_ids: guestsIds,
                                event_id: event.id,
                                events_annexes_ids: events_annexes_ids
                            }

                            //Guardamos los actos
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'EventsGuests/SetAnnexesGuest',
                                data: annexes,
                            }).then(function (resultsImage, status, headers, config) {
                                toastr.success($filter('translate')('events.guests.action_success'));
                            });
                        }
                    });
                }
            };

            $scope.assignSpaces = async function () {

                let selectedGuestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();

               // let selectedGuestsIds = $scope.items.filter(f => f.value != null).map(m => m.id);

                if (selectedGuestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {

                    let spaces = await eventService.getSpaces(event.id);
                    spaces.push({ id: -1, name: $filter('translate')('events.guests.no_space') });

                    /*
                        spaces.forEach(function (space) {
                            space.FK_events_spaces_zones_events_spaces.push({ id: -1, name: $filter('translate')('events.guests.no_zone') })
                        });
                    */ 

                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: GuestSpaceZonesModalView,
                        controller: "GuestSpaceZonesModalCtrl",
                        size: 'md',
                        resolve: {
                            event_guest_zone: function () {
                                return undefined;
                            },
                            event_guest_id: function () {
                                return null;
                            },
                            spaces: function () {
                                return spaces;
                            }
                        }
                    });

                    // Retorno de los datos desde el modal.
                    $modalInstance.result.then(function (resultModal) {

                        let spaceID = resultModal.spaceSelected.id;
                        let zoneID = spaceID > 1 ? resultModal.event_guest_zone.id : null;

                        Restangular.all('EventsGuests/MassiveChangeSpaceZone/' + spaceID + '/' + zoneID).post(selectedGuestsIds).then(function (response) {
                            $scope.loadGuests();
                            toastr.success($filter('translate')('events.guests.action_success'));
                        }, function (error) {
                            logService.error(error);
                            var errorMessage = "Error desconocido";
                            if (error.data?.ExceptionMessage != null) errorMessage = error.data.ExceptionMessage;
                            $scope.loadGuests();
                            toastr.error(errorMessage);
                        });
                    });

                }
            }


            $scope.assignTags = function () {

                let listIds = _.chain($scope.invitedGuests)
                    .filter(function (guest) {
                        return angular.isDefined(guest.value) && guest.value != ""; // Filtramos solo los seleccionados
                    })
                    .map(function (guest) {
                        return guest.person_id;
                    })
                    .value(); // Traemos un array de persons_id

                if (listIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('persons.select_authority'),
                        onAccept: function () { }
                    });
                } else {

                    let $modalInstance = $uibModal.open({
                        animation: true,
                        template: AssignTagsModalView,
                        size: "ld",
                        controller: "tagsModalCtrl",
                        scope: $scope,
                        resolve: {

                            is_search: function () {
                                return false
                            },
                            selected_tags_ids: function () {
                                return [];
                            },
                            entity_type: function () {
                                return "persons";
                            },
                            entity_id: function () {
                                return listIds;
                            }
                        }
                    });

                    $modalInstance.result.then(function (resultModal) {
                        $scope.loadGuests();
                    });
                }
            }


            $scope.loadGuests();

            $scope.sendPushNotifications = function () {

                let guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length === 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                    let params = {
                        listIds: guestsIds,
                        type: 'guest',
                        event_id: $stateParams.id
                    };
                    notificationService.notificationPush({
                        params: params,
                        onAccept: function (data) {
                            toastr.success($filter('translate')('notifications.sending_mail_success'));
                        }
                    });
                }
            }

            // REVISAR
            $scope.sendNotifications = function () {
                let guestsIds = _.chain($scope.invitedGuests)
                    .filter(function (option) {
                        return angular.isDefined(option.value) && option.value != "";
                    })
                    .map(function (option) {
                        return option.value;
                    })
                    .value();
                if (guestsIds.length == 0) {
                    modalService.message({
                        title: "Error",
                        message: $filter('translate')('events.guests.select_persons'),
                        onAccept: function () {
                        }
                    });
                } else {
                    if (event.mail_account_id == null || event.mail_account_id == 0) {
                        modalService.message({
                            title: "Error",
                            message: $filter('translate')('events.select_mail_from_address'),
                            onAccept: function () {
                            }
                        });
                    } else {

                        var params = {
                            entity_type: "events",
                            entity_type_id: $stateParams.id,
                            event_guests_ids: guestsIds,
                            mail_account_id: event.mail_account_id,
                            mail_account_reply: event.reply_to,
                            documents: {for_event_guest: true}
                        };

                        notificationService.notificationMail({
                            params: params,
                            onAccept: function (data) {
                                toastr.success($filter('translate')('notifications.sending_mail_success'));
                            }
                        });
                    }
                }
            }

            $scope.searchByIncident = function () {
                $scope.showIncidents = true;
                $scope.paginationOptions.currentPage = 0;
                $scope.loadGuests();
            }

            $scope.export = function () {

                // Mandamos los ID de los items después del filtro 
                let filteredItemsIds = $scope.items.map(i => i.id);

                let options = {
                    filters: {
                        NAME: $scope.search.name,
                        EVENT_ID: $stateParams.id
                    },
                    GUEST_LIST_INCLUDE_ACTS: true,
                    FILTERED_IDS: filteredItemsIds,
                };

                let n = 0;
                for (let key in $scope.search.pigs) {
                    n++;
                    options.filters["PIG" + n] = "#" + key + "=" + $scope.search.pigs[key] + "#";
                }

                datasetsService.exportByType("event_guests", options);

            };

            let importCSVConfigured = false;

            let initImportCSV = function () {
                $("#frmCSV").change(function () {
                    let fileInput = document.querySelector<HTMLInputElement>('#frmCSV');
                    let file = fileInput?.files?.[0];
                    if (file) {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            const codes = new Uint8Array(e.target?.result as ArrayBuffer);
                            const detectedEncoding = Encoding.detect(codes);
                            try {
                                let unicodeString = Encoding.convert(codes, {
                                    to: 'unicode',
                                    from: detectedEncoding,
                                    type: 'string'
                                });

                                let request = {
                                    file: btoa(unicodeString),
                                    person_type: "anonymous",
                                    mime: file.type
                                }
                                Restangular.all('Persons/ImportCSV?event_id=' + $stateParams.id).post(request).then(function (data) {
                                    if (data && data.length > 0) {
                                        $state.go('events.edit.guests.import', {
                                            event_id: $stateParams.id,
                                            people: data,
                                            menu_item_id: $stateParams.menu_item_id
                                        });
                                    } else {
                                        let fileInput = document.querySelector<HTMLInputElement>('#frmCSV');
                                        if (fileInput) {
                                            fileInput.value = "";
                                        }
                                    }
                                }, function (error) {
                                    let exceptionString = error.data.Message
                                    // Para que esté "a prueba de funcionarios", pasamos el error por un modal. Así les obliga a leer el mensaje para seguir trabajando
                                    modalService.message({
                                        title: $filter('translate')('events.guests.invalid_csv_title_boring'),
                                        message: exceptionString,  
                                        onAccept: function () {
                                        }
                                    });

                                    // Borramos el fichero de memoria
                                    let fileInput = document.querySelector<HTMLInputElement>('#frmCSV');
                                    if (fileInput) {
                                        fileInput.value = "";
                                    }
                                });
                            } catch (e) {
                                // Uncaught RangeError: Maximum call stack size exceeded
                            }
                        };
                        reader.readAsArrayBuffer(file);
                        // Borramos el value para que entre en la función al intentar cargar por segunda vez un archivo con el mismo nombre
                        const fileInput = document.querySelector('#frmCSV') as HTMLInputElement;
                        if (fileInput) {
                            fileInput.value = "";
                        }
                    }
                });
            };

            $scope.importCSV = function () {
                if (!importCSVConfigured) {
                    importCSVConfigured = true;
                    initImportCSV();
                }
                $("#frmCSV").trigger("click");
            };

            let updateCSVConfigured = false;

            let initUpdateCSV = function () {
                $("#frmCSV2").change(function () {
                    let fileInput = document.querySelector('#frmCSV2') as HTMLInputElement;
                    let file = fileInput?.files?.[0];
                    if (file) {
                        let reader = new FileReader();
                        reader.onload = function (e) {
                            if (!e.target) return;
                            const codes = new Uint8Array(e.target.result as ArrayBuffer);
                            const detectedEncoding = Encoding.detect(codes);
                            try {
                                let unicodeString = Encoding.convert(codes, {
                                    to: 'unicode',
                                    from: detectedEncoding,
                                    type: 'string'
                                });

                                let request = {
                                    file: btoa(unicodeString),
                                    person_type: "anonymous",
                                    mime: file.type
                                }

                                Restangular.all('EventsGuests/UpdateCSV?event_id=' + $stateParams.id).post(request).then(function (data) {
                                    toastr.success($filter('translate')('persons.import_csv.success'));
                                    $scope.loadGuests();
                                });
                            } catch (e) {
                                // Uncaught RangeError: Maximum call stack size exceeded
                            }
                        };

                        reader.readAsArrayBuffer(file);
                    }
                });
            };

            $scope.updateCSV = function () {
                if (!updateCSVConfigured) {
                    updateCSVConfigured = true;
                    initUpdateCSV();
                }
                $("#frmCSV2").trigger("click");
            };

            function invertColor(hex) {
                if (hex != null && hex !== 'undefined' && hex != "") {
                    if (hex.indexOf('#') === 0) {
                        hex = hex.slice(1);
                    }
                    // convert 3-digit hex to 6-digits.
                    if (hex.length === 3) {
                        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
                    }
                    if (hex.length !== 6) {
                        throw new Error('Invalid HEX color.');
                    }
                    var r = parseInt(hex.slice(0, 2), 16),
                        g = parseInt(hex.slice(2, 4), 16),
                        b = parseInt(hex.slice(4, 6), 16);

                    return (r * 0.299 + g * 0.587 + b * 0.114) > 186
                        ? '#000000'
                        : '#FFFFFF';
                } else {
                    return "#000000";
                }
            }

            //Mass confirmation 
            $scope.confirmSelected = function () {
                let selectedToConfirm = $scope.items.filter(f => f.value != null && f.confirmation_status != "confirmed");
                let selectedToCheck = $scope.items.filter(f => f.value != null);

                let date = new Date();
                let day = date.getDate();
                let month = date.getMonth() + 1;
                let year = date.getFullYear();

                modalService.confirm({
                    title: $filter('translate')('events.guests.confirm_selected'),
                    message: $filter('translate')('events.guests.confirm_selected_message'),
                    onAccept: function () {

                        Restangular.all('EventsGuests/massiveConfirmation/confirmed').post(selectedToConfirm).then(function (result) {
                            selectedToConfirm.forEach((item) => {
                                item.confirmation_status = "confirmed";
                                item.confirmation_date = `${day}/${month}/${year}`;
                            });
                            $scope.loadGuests();
                        });

                        // Asignamos a los actos en cuestion 
                        Restangular.all("EventsProgramsActs").customGET("GetEventConfirmableActs", { event_id: event.id }).then(function (res) {

                            if (res.length > 0) {
                                let epag = {
                                    event_acts_ids: res.map(m => m.id),
                                    guests_id: selectedToCheck.map(e => e.id),
                                    event_id: event.id,
                                    guest_id: null,
                                    event_acts_show_ids: null
                                }
                                Restangular.all("EventsGuests").customPOST(epag, "SetMassiveActsGuest", {onlyConfirmableActs: true}).then(function (results) {
                                    selectedToCheck.forEach(m => m.partial_attendance = false)
                                });
                            };
                        });
                    }
                });
                // Metemos aquí el método para añadir parciales 
            }
        }])


    .controller("SearchGuestsModalCtrl", ['uiGridSelectionService', '$timeout', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'options', '$rootScope', function (uiGridSelectionService, $timeout, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, options, $rootScope) {

        // Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_GUESTS_WRITE");

        $scope.searchModal = {pigs: []};
        $scope.showError = false;
        $scope.selectedRows = [];
        $scope.options = options;
        $scope.showResults = false;
        $scope.personPositionModal = {};
        $scope.personPositionOrigin = {};
        $scope.personPositionModal.persons_groups = {};

        function refreshGuestsView() {
            if ($scope.options && typeof $scope.options.onGuestsAdded === 'function') {
                $scope.options.onGuestsAdded();
            }
        }

        // $scope.personPositionModal.persons_persons_treatments = {};
        // $scope.personPositionModal.persons_position_treatments = {};
        $scope.personPositionModal.FK_positions_groups = null;
        $scope.type_persons = [

            {option: null, label: $filter('translate')('persons.title_all'), checked: true},
            {option: "authority", label: $filter('translate')('persons.title'), checked: false},
            {option: 'anonymous', label: $filter('translate')('persons.title_anonymous'), checked: false}

        ];
        $scope.typePersonSelected = {checked: $scope.type_persons[0].option};

        if ($scope.personPositionModal.position_order == 0) $scope.personPositionModal.position_order = null;

        //cargamos los grupos de información
        let optionsPIG = {entity_type: "persons"};
        Restangular.all('InformationsGroups').getList(optionsPIG).then(function (personsInformationGroups) {
            $scope.personsInformationGoups = personsInformationGroups.filter(m => m.use_in_search == true);
            $scope.personsInformationGoups.forEach(function (pig) {
                if (pig.configuration != "") pig.configuration = JSON.parse(pig.configuration);
            });
            $scope.checkboxSimpleOptions = [
                {option: null, label: $filter('translate')('informations.all'), checked: true},
                {option: true, label: $filter('translate')('events.staff.yes'), checked: false},
                {option: false, label: $filter('translate')('events.staff.no'), checked: false}
            ];
        });

        //Custom function.  return null values instead of undefined
        function isDefinedAndNotNull(val) {

            return angular.isDefined(val) && val !== null;

        }

        $scope.parsePersonType = function (person_type) {

            var result = "";

            if (person_type == "authority") {

                result = $filter('translate')('persons.title');

            } if (person_type === "anonymous") {

                result = $filter('translate')('persons.title_anonymous');

            } else if (person_type === "imported") {

                result = $filter('translate')('persons.title_imported');

            } else if (person_type === "enrolled") {

                result = $filter('translate')('inscriptions_forms.inscripted');

            }

            return result;

        };

        let group_id = "";
        let position_id = "";

        $scope.searchGuestsOptions = function () {
            $scope.selectedRows = [];
            //gridGuestsOptions;
            $scope.showResults = true;
            if (isDefinedAndNotNull($scope.personPositionModal.FK_positions_groups)) {
                position_id = $scope.personPositionModal.FK_positions_groups.selected.id;
            }
            if (angular.isDefined($scope.personPositionModal.persons_groups.selected)) group_id = $scope.personPositionModal.persons_groups.selected.id;

            if (!angular.isDefined($scope.searchModal)) {
                $scope.searchModal = {};
                $scope.searchModal.name2 = "";
                $scope.searchModal.surname = "";
                $scope.searchModal.lastname = "";
                $scope.searchModal.historic_position = false;
            }

            if (angular.isDefined($scope.gridGuestsOptions)) {
                $scope.gridGuestsOptions.loadData(false);
                //quitamos la seleccion
                //$scope.gridGuestsOptions.gridApi.selection.clearSelectedRows();
            } else {
                $scope.gridGuestsOptions = {
                    exporterMenuCsv: false,
                    enableGridMenu: true,
                    enableHiding: false,
                    enableSelectionBatchEvent: true,//para obtener los seleccionados
                    gridMenuShowHideColumns: false,
                    paginationPageSizes: [5, 10, 25],
                    paginationPageSize: 5,
                    onRegisterApi: function (gridApi) {
                        this.gridApi = gridApi;
                        this.gridApi.core.on.rowsRendered($scope, callbackFunctionItemChange);
                        this.gridApi.selection.on.rowSelectionChanged($scope, callbackFunctionRowSelected);
                        this.gridApi.selection.on.rowSelectionChangedBatch($scope, callbackFunctionRowSelected);
                    },
                    columnDefs: [
                        {
                            name: 'id',
                            visible: false,
                            enableFiltering: false,
                            enableHiding: false,
                            exporterSuppressExport: true
                        },
                        {
                            name: 'positionId',
                            visible: false,
                            enableFiltering: false,
                            enableHiding: false,
                            exporterSuppressExport: true
                        },

                        {
                            name: 'death',
                            width: 25,
                            displayName: "",
                            enableFiltering: false,
                            enableHiding: false,
                            enableColumnMenu: false,
                            cellTemplate: '<div  class="ui-grid-cell-contents">' +
                                '<i class="fa fa-solid fa-cross text-danger" ng-if="row.entity.death_date!=null" ></i>' +
                                '</div>'
                        },

                        {
                            field: 'photo',
                            nableFiltering: false,
                            enableSorting: false,
                            displayName: $filter('translate')('persons.photo'),
                            cellTemplate: "<div style='height: 28px; overflow: hidden;'><img width=\"30px\" ng-show=\"grid.getCellValue(row, col)\"  ng-src=\"{{grid.getCellValue(row, col)}}\" style=\"margin-left:10px;margin-top:5px;\" lazy-src></div>",
                            width: 70,
                            enableFiltering: false

                        },
                        {
                            name: 'position_and_group_name',
                            displayName: $filter('translate')('persons.position'),
                            enableFiltering: false,
                            enableSorting: false,
                            enableHiding: false,
                            minWidth: 200,
                            cellTemplate: '<div popover-placement="top" popover-append-to-body="true" type="button" popover-trigger="mouseenter" uib-popover="{{grid.getCellValue(row, col)}}"  class="ui-grid-cell-contents">' +
                                '<span >{{grid.getCellValue(row, col)}}</span>' +
                                '</div>'
                        },
                        {
                            name: 'name',
                            displayName: $filter('translate')('persons.name'),
                            enableFiltering: true,
                            enableSorting: true,
                            enableHiding: false
                        },
                        {
                            name: 'surname',
                            displayName: $filter('translate')('persons.surname'),
                            enableFiltering: true,
                            enableSorting: true,
                            enableHiding: false
                        },
                        {
                            name: 'lastname',
                            displayName: $filter('translate')('persons.lastname'),
                            enableFiltering: true,
                            enableSorting: true,
                            enableHiding: false
                        },
                        {
                            name: 'person_type',
                            displayName: $filter('translate')('persons.type'),
                            enableFiltering: true,
                            cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{grid.appScope.parsePersonType(row.entity.person_type)}}</div>'
                        },
                    ],
                    getData: function (options) {
                        var deferred = $q.defer();
                        options.event_id = $stateParams.id;
                        options.group_id = group_id;
                        options.position_id = position_id;
                        options.group_position_name = $scope.searchModal.group_position_name;
                        options.nameSearch = $scope.searchModal.name2;
                        options.surnameSearch = $scope.searchModal.surname;
                        options.lastnameSearch = $scope.searchModal.lastname;
                        options.state = $scope.searchModal.state;
                        options.tags = $scope.tags;
                        var pigs = "";

                        for (var key in $scope.searchModal.pigs) {
                            if (typeof $scope.searchModal.pigs[key] != "undefined" && $scope.searchModal.pigs[key] != "" && $scope.searchModal.pigs[key] != null) {
                                if (typeof ($scope.searchModal.pigs[key]) == "object") {
                                    //estamos en el selector simple.
                                    var infoFilter = $scope.personsInformationGoups.filter(function (el) {
                                        return el.id == key;
                                    });
                                    if (infoFilter.length == 1) {
                                        if (infoFilter[0].type == "datetime") {
                                            if ($scope.searchModal.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.searchModal.pigs[key]).toISOString();
                                        } else if (infoFilter[0].type == "checkboxSimple") {
                                            if ($scope.searchModal.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key].checked;
                                        } else {
                                            pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key];
                                        }
                                    }
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key];
                                }
                            }
                        }
                        options.pigs = pigs;
                        options.historic_position = $scope.searchModal.historic_position;
                        options.person_type = $scope.typePersonSelected.checked;
                        options.save = false;

                        Restangular.all('EventsGuests/SearchGuestOptions').post(options).then(function (results) {
                            var data = results.rows;
                            var personsIds = [];
                            angular.forEach(data, function (dataR) {
                                if (personsIds.indexOf(dataR.id) < 0) {
                                    personsIds.push(dataR.id);
                                }
                            });
                            //Obtenemos sus imágenes
                            if (personsIds.length > 0) {
                                $http({
                                    method: 'post',
                                    url: (window as any).CONFIG.api_url + 'Persons/ImagesSmall',
                                    params: {ids: personsIds}
                                }).then(function (resultsImage, status, headers, config) {
                                    angular.forEach(data, function (person) {
                                        for (var i = 0; i < resultsImage.data.length; i++) {
                                            if (person.id == resultsImage.data[i].person_id) {
                                                person.photo = resultsImage.data[i].image_small;
                                                break;
                                            }
                                        }
                                    });
                                });
                            }
                            data.totalRows = results.totalRows;
                            $scope.totalRows = results.totalRows;
                            deferred.resolve(data);

                        });

                        return deferred.promise;

                    }
                }; //End gridoptions
            }
        };

        let callbackFunctionRowSelected = function (row, evt) {
            let addAll = row.length > 1;

            if (!addAll) {
                //buscamos si ya existe la persona añadida
                var index = $scope.selectedRows.map(function (e) {
                    return e.id;
                }).indexOf(row.entity.id);
                if (index < 0) {
                    if (row.isSelected) {
                        $scope.selectedRows.push({id: row.entity.id, positionId: [row.entity.positionId]});
                    } else {
                        $scope.selectedRows.splice(index, 1);
                    }
                } else {
                    //ya existe, si is seleccionado, lo añadimos y sino lo borramos.
                    if (row.isSelected) {
                        $scope.selectedRows.map(function (e) {
                            if (e.id == row.entity.id) e.positionId.push(row.entity.positionId)
                        });
                    } else {
 
                        for (let i = 0; i < $scope.selectedRows.length; i++) {
                            if ($scope.selectedRows[i].id == row.entity.id) {

                                //var indexPosition = $scope.selectedRows[i].positionId.map(function (e) { return e.positionId; }).indexOf(row.entity.positionId);
                                var indexPosition = $scope.selectedRows[i].positionId.indexOf(row.entity.positionId);
                                var lengthOfPositions = $scope.selectedRows[i].positionId.map(function (e) {
                                    return e.positionId;
                                }).length;
                            }
                        }

                        $scope.selectedRows.map(function (e) {
                            if (e.id == row.entity.id) e.positionId.splice(indexPosition, 1)
                        });
                        if (lengthOfPositions == 1) {
                            //eliminamos a la persona
                            var index = $scope.selectedRows.map(function (e) {
                                return e.id;
                            }).indexOf(row.entity.id);
                            $scope.selectedRows.splice(index, 1);
                        }
                    }

                }

            } else {
                if (row[0].isSelected) {
                    //se ha seleccionado todo.
                    $scope.selectedRows = [];
                    for (let i = 0; i < $scope.gridGuestsOptions.gridApi.grid.options.totalItems; i++) {
                        $scope.selectedRows.push(i);
                    }
                    ;
                } else {
                    $scope.selectedRows = [];
                }

            }
        }

        let callbackFunctionItemChange = function () {
            $timeout(function () {
                for (var i = 0; i < $scope.gridGuestsOptions.data.length; i++) {
                    var row = $scope.gridGuestsOptions.data[i];
                    for (var select = 0; select < $scope.selectedRows.length; select++) {
                        let selected = $scope.selectedRows[select];
                        if (row.id == selected.id) {
                            $scope.gridGuestsOptions.gridApi.selection.toggleRowSelection(row);
                            break
                        }
                    }
                    ;
                }
            }, 350);//lo pongo así porque sino falla la primera vez
        }

        $scope.searchByTags = function () {

            let $modalInstance = $uibModal.open({
                animation: true,
                template: AssignTagsModalView,
                size: "ld",
                controller: "tagsModalCtrl",
                scope: $scope,
                resolve: {

                    is_search: function () {
                        return true
                    },

                    selected_tags_ids: function () {
                        return $scope.tags != null ? $scope.tags.map(m => m.id) : [];
                    },

                    entity_type: function () {
                        return "persons";
                    },
                    entity_id: function () {
                        return null;
                    }
                }
            });

            $modalInstance.result.then(function (tagIdList) {
                $scope.tags = [];
                if (tagIdList != null && tagIdList.length > 0) {

                    Restangular.all("Tags").customGET("TagsByIdList", { id_list: tagIdList }).then(function (results) {
                        $scope.tags = results;
                    });
                }
            }, function () {
            });
        }
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addGuests = function (continueOption) {
            
            var addAll = $scope.gridGuestsOptions.gridApi.selection.getSelectAllState();
            if (addAll) {
                let options: any = {};
                options.event_id = $stateParams.id;
                options.group_id = group_id;
                options.position_id = position_id;
                options.nameSearch = $scope.searchModal.name2;
                options.surnameSearch = $scope.searchModal.surname;
                options.lastnameSearch = $scope.searchModal.lastname;
                options.historic_position = $scope.searchModal.historic_position;
                options.person_type = $scope.typePersonSelected.checked;
                options.group_position_name = $scope.searchModal.group_position_name;
                options.state = $scope.searchModal.state;
                options.tags = $scope.tags;
                var pigs = "";
                for (var key in $scope.searchModal.pigs) {
                    if (typeof $scope.searchModal.pigs[key] != "undefined" && $scope.searchModal.pigs[key] != "" && $scope.searchModal.pigs[key] != null) {
                        if (typeof ($scope.searchModal.pigs[key]) == "object") {
                            //estamos en el selector simple.
                            //if ($scope.searchModal.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key].checked;
                            var infoFilter = $scope.personsInformationGoups.filter(function (el) {
                                return el.id == key;
                            });
                            if (infoFilter.length == 1) {
                                if (infoFilter[0].type == "datetime") {
                                    if ($scope.searchModal.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.searchModal.pigs[key]).toISOString();
                                } else if (infoFilter[0].type == "checkboxSimple") {
                                    if ($scope.searchModal.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key].checked;
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key];
                                }
                            }
                        } else {
                            pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key];
                        }
                    }
                }

                options.pigs = pigs;

                //si no hay al menos un filtro, no dejamos añadir, porque añadirian toda la bd
                if ((options.group_id == "" || options.group_id == null) &&
                    (options.group_position_name == "" || options.group_position_name == null) &&
                    (options.nameSearch == "" || options.nameSearch == null) &&
                    (options.surnameSearch == "" || options.surnameSearch == null) &&
                    (options.lastnameSearch == "" || options.lastnameSearch == null) &&
                    (options.group_position_name == "" || options.group_position_name == null) &&
                    (options.state == "" || options.state == null) &&
                    (options.pigs == "" || options.pigs == null) &&
                    ($scope.tags.length == 0)
                ) {
                    alert("Debes indicar al menos un filtro.");
                    return;
                }
                Restangular.all('EventsGuests/AddAllPersonsToEvent').post(options).then(function (results) {
                    // Devolvemos el control al principal
                    if (results) {
                        if (continueOption == 0) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                            $uibModalInstance.close();
                        } else {
                            if (!$scope.$$phase) $scope.$apply();
                            refreshGuestsView();
                            if ($scope !== undefined && $scope != null && typeof $scope.gridGuestsOptions.loadData === 'function') {
                                $scope.gridGuestsOptions.loadData(false);
                            }
                        }
                    } else {
                        toastr.error($filter('translate')('events.guests.event_closed'));
                    }
                });
            } else {
                //Devolvemos el control al principal
                //var rows = $scope.gridGuestsOptions.gridApi.selection.getSelectedRows(); esta guardado en el seleccionado.
                var ids = new Array();
                angular.forEach($scope.selectedRows, function (row) {
                    let positionIdSelected = null;

                    if (row.positionId.length <= 1) {
                        positionIdSelected = row.positionId[0];
                    }
                    let aux = {
                        guest_id: row.id,
                        position_id: positionIdSelected
                    }
                    ids.push(aux);
                });

                if (ids.length > 0) {
                    var guestsOptions = {event_id: $stateParams.id, guests_position: ids};
                    Restangular.all('EventsGuests/AddPersonsToEvent').post(guestsOptions).then(function (result) {
                        if (result) {
                            toastr.success($filter('translate')('events.guests.action_success'));
                            if (continueOption == 0) {
                                $uibModalInstance.close();
                            } else {
                                if (!$scope.$$phase) $scope.$apply();
                                refreshGuestsView();
                                $scope.gridGuestsOptions.loadData(false);
                            }
                        } else {
                            toastr.error($filter('translate')('events.guests.event_closed'));
                        }
                    });
                }
            }

        };//savePersonPosition

        $scope.addGuestsCompanion = function () {

            $scope.showError = false;
            var addAll = $scope.gridGuestsOptions.gridApi.selection.getSelectAllState();

            if (addAll) {

                // Ha seleccionado todos, volvemos a buscar sin pagina.
                options = {};
                options.event_id = $stateParams.id,
                options.nameSearch = $scope.searchModal.name2,
                options.surnameSearch = $scope.searchModal.surname,
                options.lastnameSearch = $scope.searchModal.lastname;
                options._page = null;
                options._pageSize = null;
                options.person_type = $scope.typePersonSelected.checked;
                options.historic_position = $scope.searchModal.historic_position;

                //Pigs
                var pigs = "";

                for (var key in $scope.searchModal.pigs) {
                    if (typeof $scope.searchModal.pigs[key] != "undefined" && $scope.searchModal.pigs[key] != "" && $scope.searchModal.pigs[key] != null) {
                        if (typeof ($scope.searchModal.pigs[key]) == "object") {

                            //estamos en el selector simple. 
                            var infoFilter = $scope.personsInformationGoups.filter(function (el) {
                                return el.id == key;
                            });
                            if (infoFilter.length == 1) {
                                if (infoFilter[0].type == "datetime") {
                                    if ($scope.searchModal.pigs[key] != null) pigs += (pigs != "" ? "#" : "") + key + "=>" + new Date($scope.searchModal.pigs[key]).toISOString();
                                } else if (infoFilter[0].type == "checkboxSimple") {
                                    if ($scope.searchModal.pigs[key].checked != "") pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key].checked;
                                } else {
                                    pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key];
                                }
                            }
                        } else {
                            pigs += (pigs != "" ? "#" : "") + key + "=>" + $scope.searchModal.pigs[key];
                        }
                    }
                }

                options.pigs = pigs;

                Restangular.all('EventsGuests/SearchGuestOptions').post(options).then(function (results) {

                    var rows_data = new Array();
                    var rows = results.rows;
                    angular.forEach(rows, function (row) {
                        rows_data.push({
                            id: row.id,
                            name: row.name + " " + (isDefinedAndNotNull(row.surname) ? row.surname : "") + " " + (isDefinedAndNotNull(row.lastname) ? row.lastname : "")
                        });
                    });
                    if ($scope.options.limit == 0 || rows_data.length + $scope.options.total <= $scope.options.limit) {
                        //Devolvemos el control al principal
                        $uibModalInstance.close(rows_data);
                    } else {
                        $scope.showError = true;
                    }

                });
            } else {

                //Devolvemos el control al principal
                var rows = $scope.gridGuestsOptions.gridApi.selection.getSelectedRows();
                var rows_data = new Array();
                angular.forEach(rows, function (row) {
                    rows_data.push({
                        id: row.id,
                        name: row.name + " " + (isDefinedAndNotNull(row.surname) ? row.surname : "") + " " + (isDefinedAndNotNull(row.lastname) ? row.lastname : "")
                    });
                });
                if ($scope.options.limit == 0 || rows_data.length + $scope.options.total <= $scope.options.limit) {
                    //Devolvemos el control al principal
                    $uibModalInstance.close(rows_data);
                } else {
                    $scope.showError = true;
                }
            }
        }

        $scope.addNewPerson = function (person_type) {
            let $modalInstance = null;
            if ($rootScope.sizeLg) {
                $modalInstance = $uibModal.open({
                    animation: true,
                    template: AddNewPersonModalView,
                    size: "xl-lg",
                    controller: "AddNewPersonModalCtrl",
                    resolve: {
                        person_type: function () {
                            return person_type;
                        },
                    }
                });
            } else {
                $modalInstance = $uibModal.open({
                    animation: true,
                    size: "xl-lg",
                    template: AddNewPersonModalView,
                    controller: "AddNewPersonModalCtrl",
                    resolve: {
                        person_type: function () {
                            return person_type;
                        },
                    }
                });
            }
        };

    }])

    .controller("AddNewPersonModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'person_type', '$rootScope', function (LoginService, $scope, $uibModalInstance, person_type, $rootScope) {
        // Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_GUESTS_WRITE");
        $scope.person_type = person_type;
        $scope.callbackClose = function (mode) {
            $uibModalInstance.dismiss(mode);
        };

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }])

    .controller("ConfigGuestsModalCtrl", ['generateDocumentService', 'gridService', 'event', 'item', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', '$state', '$rootScope', 'eventService', 'logService',
        function (generateDocumentService, gridService, event, item, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, $state, $rootScope, eventService, logService) {

            // Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("EVENTS_GUESTS_WRITE");
            $scope.allowReadPersons = LoginService.permissionExist("PERSONS_READ");
            $scope.haveEspecificActs = false;
            $scope.haveEspecificAnnexes = false;
            $scope.eventsProgramsActSelected = [];
            $scope.eventsDocumentTypeSelected = [];
            $scope.hasSomethingToConfig = false;
            $scope.name = item.name;
            $scope.partial = $filter('translate')('events.guests.partial_attendance_uncheck');

            $scope.parkingOptions = [{ name: $filter('translate')('events.guests.use_event_config'), value: false }, { name: $filter('translate')('events.guests.use_custom_config'), value: true }]

            $scope.referrer_person_id = item.referrer_person_id;
            if (item.surname != null)
                $scope.name += ' ' + item.surname;
            if (item.lastname != null)
                $scope.name += ' ' + item.lastname;
            $scope.positionChecked = {
                parking: null
            };

            $scope.companionTexts = {
                tab_title: $filter('translate')('events.guests.title_companions'),
            };

            function isDefinedAndNotNull(val) {

                return angular.isDefined(val) && val !== null;

            }

            function isDefinedAndNotNullOrEmpty(val) {

                return angular.isDefined(val) && val !== null && val !== "";

            }

            $scope.checkPartialAttendance = function () {

                if ($scope.eventsConfirmableActs && $scope.confirmation_status_value == "confirmed") {
                    $scope.guest.partial_attendance = $scope.eventsConfirmableActs.some(act => $scope.eventsProgramsActSelected[act.id] != "attend");
                    if ($scope.guest.partial_attendance) {
                        $scope.partial = $filter('translate')('events.guests.partial_attendance_check');
                        $scope.confirmationStatus[1].name = $filter('translate')('events.guests.confirmed') + ' ' + $scope.partial;

                    } else {
                        $scope.partial = $filter('translate')('events.guests.partial_attendance_uncheck');
                        $scope.confirmationStatus[1].name = $filter('translate')('events.guests.confirmed') + ' ' + $scope.partial;

                    }
                };
            }

            // Tipo de acreditación del invitado en el evento
            Restangular.all('EventsGuestsAccreditations').getList({event_id: event.id}).then(function (results) {
                $scope.accreditationsList = results;
                $scope.accreditationsList.push({id: null, name: $filter('translate')('events.guests.no_accreditation')})
            });

            $scope.goToPerson = function () {
                var url = $state.href('persons.edit', {
                    id: $scope.guest.person_id,
                    person_type: $scope.guest.person_type
                });
                window.open(url, '_blank');
            };

            // Tiene algun acto especifico para marcar a los invitados.
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + 'EventsProgramsActs/GetEventEspecificActs',
                params: {event_id: event.id}
            }).then(function (results, status, headers, config) {
                $scope.eventsSpecificActs = results.data;
                if ($scope.eventsSpecificActs.length > 0) {
                    $scope.haveEspecificActs = true;
                    var epag = {
                        guest_id: item.id,
                        event_id: event.id
                    }
                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'EventsGuests/GetActsGuest',
                        data: epag
                    }).then(function (result, status, headers, config) {
                        angular.forEach(result.data.event_acts_ids, function (item) {
                            $scope.eventsProgramsActSelected[item] = "attend";
                        });
                        angular.forEach(result.data.event_acts_show_ids, function (item) {
                            $scope.eventsProgramsActSelected[item] = "show";
                        });

                    });
                }
            });

            // Tiene algun acto que requiera una confirmación a parte.
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + 'EventsProgramsActs/GetEventConfirmableActs',
                params: {event_id: event.id}
            }).then(function (results, status, headers, config) {
                $scope.eventsConfirmableActs = results.data;
                if ($scope.eventsConfirmableActs.length > 0) {
                    $scope.haveConfirmableActs = true;
                    var epag = {
                        guest_id: item.id,
                        event_id: event.id
                    }

                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'EventsGuests/GetActsGuest',
                        data: epag
                    }).then(function (result, status, headers, config) {
                        angular.forEach(result.data.event_acts_ids, function (item) {
                            $scope.eventsProgramsActSelected[item] = "attend";
                        });
                    });
                }
            });

            $scope.eventsAnnexesSelected = [];
            Restangular.all('EventsAnnexes').getList({
                event_id: event.id,
                is_explicit_annex: true
            }).then(function (response) {
                $scope.annexes = response;
                angular.forEach($scope.annexes, function (row) {
                    row.FK_events_programs_annexes_tl_events_programs_annexes = row.FK_events_programs_annexes_tl_events_programs_annexes.find(element => element.language_id == $rootScope.languageId);
                });

                if ($scope.annexes.length > 0) {
                    $scope.haveEspecificAnnexes = true;
                    var epag = {
                        event_guest_id: item.id,
                        event_id: event.id
                    }

                    $http({
                        method: 'post',
                        url: (window as any).CONFIG.api_url + 'EventsGuests/GetAnnexesGuest',
                        data: epag
                    }).then(function (result, status, headers, config) {
                        angular.forEach(result.data.events_annexes_ids, function (item) {
                            $scope.eventsAnnexesSelected[item] = "checked";
                        });
                    });

                }
            });

            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + 'EventsProgramsActs/GetConfigMenus',
                params: {event_id: event.id, event_guest_id: item.id}
            }).then(function (results, status, headers, config) {
                $scope.eventsProgramsActs = results.data;
                if ($scope.eventsProgramsActs.length > 0) {
                    $scope.hasSomethingToConfig = true;
                }

                //Seleccionamos el principal
                angular.forEach($scope.eventsProgramsActs, function (programAct) {
                    angular.forEach(programAct.FK_events_programs_acts_menus_events_programs_acts, function (menu) {
                        if (menu.is_principal) programAct.FK_events_programs_acts_menus_events_programs_acts.selected = menu;
                    });
                });

                //Buscamos si hay alguno con menú especial y lo seleccionamos.
                angular.forEach($scope.eventsProgramsActs, function (programAct) {
                    angular.forEach(programAct.FK_events_programs_acts_menus_events_programs_acts, function (menu) {
                        angular.forEach(programAct.FK_events_programs_acts_menus_guests_events_programs_acts, function (menu_guest) {
                            if (menu_guest.event_guest_id == item.id && menu.event_program_act_id == menu_guest.event_program_act_id && menu_guest.event_program_act_menu_id == menu.id) {
                                programAct.FK_events_programs_acts_menus_events_programs_acts.selected = menu;
                            }
                        });
                    });
                });

                $scope.confirmationStatus = [
                    {name: $filter('translate')('events.guests.pending'), value: 'pending'},
                    {name: $filter('translate')('events.guests.confirmed') + ' ' + $scope.partial, value: 'confirmed'},
                    {name: $filter('translate')('events.guests.rejected'), value: 'rejected'},
                    {name: $filter('translate')('events.guests.pending_approval'), value: 'pending_approval'},
                    {name: $filter('translate')('events.guests.manage_delegate'), value: 'manage_delegate'},
                    {name: $filter('translate')('events.guests.delegated'), value: 'delegated'}
                ];
                $scope.sendStatus = [
                    {name: $filter('translate')('events.guests.send_status_unsent'), value: 'unsent'},
                    {name: $filter('translate')('events.guests.send_status_mail'), value: 'mail'},
                    {name: $filter('translate')('events.guests.send_status_print'), value: 'print'},
                    {name: $filter('translate')('events.guests.send_status_inscription'), value: 'inscription'}
                ];
                $scope.isCompanionsAllowed = [
                    {name: $filter('translate')('events.guests.isCompanionsLikeEvent'), value: null},
                    {name: $filter('translate')('events.staff.yes'), value: true},
                    {name: $filter('translate')('events.staff.no'), value: false}
                ];

                $scope.showContactInfoPhone = false;
                $scope.showContactInfoEmail = false;

                //if (item.person_id != null && typeof (item.person_id) !== 'undefined') {
                let options = {event_id: event.id, person_id: item.person_id};
                //} else {
                //    options = { event_id: event.id, person_id: item.id };
                //}

                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/GetGuestInfoByPerson',
                    params: options
                }).then(function (results, status, headers, config) {
                    $scope.guest = results.data;

                    if ($scope.guest.partial_attendance) {
                        $scope.partial = $filter('translate')('events.guests.partial_attendance_check');
                        $scope.confirmationStatus[1].name = $filter('translate')('events.guests.confirmed') + ' ' + $scope.partial;

                    } else {
                        $scope.partial = $filter('translate')('events.guests.partial_attendance_uncheck');
                    };

                    $scope.guest.id = item.id;

                    if ($scope.guest.confirmation_status == 'pending') {
                        var statusObject = {name: $filter('translate')('events.guests.pending'), value: 'pending'};
                    } else if ($scope.guest.confirmation_status == 'confirmed') {
                        var statusObject = {name: $filter('translate')('events.guests.confirmed'), value: 'confirmed'};
                    } else if ($scope.guest.confirmation_status == 'rejected') {
                        var statusObject = {name: $filter('translate')('events.guests.rejected'), value: 'rejected'};
                    } else if ($scope.guest.confirmation_status == 'pending_approval') {
                        var statusObject = {
                            name: $filter('translate')('events.guests.pending_approval'),
                            value: 'pending_approval'
                        };
                    } else if ($scope.guest.confirmation_status == 'manage_delegate') {
                        var statusObject = {
                            name: $filter('translate')('events.guests.manage_delegate'),
                            value: 'manage_delegate'
                        };
                    } else {
                        var statusObject = {name: $filter('translate')('events.guests.delegated'), value: 'delegated'};
                    }

                    if ($scope.guest.send_status == "unsent") {
                        var sendStatusObject = {
                            name: $filter('translate')('events.guests.send_status_unsent'),
                            value: 'unsent'
                        };
                    } else if ($scope.guest.send_status == 'mail') {
                        var sendStatusObject = {
                            name: $filter('translate')('events.guests.send_status_mail'),
                            value: 'mail'
                        };
                    } else if ($scope.guest.send_status == 'inscription') {
                        var sendStatusObject = {
                            name: $filter('translate')('events.guests.send_status_inscription'),
                            value: 'inscription'
                        };
                    } else {
                        var sendStatusObject = {
                            name: $filter('translate')('events.guests.send_status_print'),
                            value: 'print'
                        };
                    }

                    let isCompanionsAllowedObject: any = undefined;

                    if ($scope.guest.is_companions_allowed) {
                        isCompanionsAllowedObject = {
                            name: $filter('translate')('events.guests.isCompanionsAllowed'),
                            value: true
                        };
                    } else if ($scope.guest.is_companions_allowed == false) {
                        isCompanionsAllowedObject = {
                            name: $filter('translate')('events.guests.isCompanionsNotAllowed'),
                            value: false
                        };
                    } else {
                        isCompanionsAllowedObject = {
                            name: $filter('translate')('events.guests.isCompanionsLikeEvent'),
                            value: null
                        };
                    }

                    let accreditation: any = undefined;

                    angular.forEach($scope.accreditationsList, function (item) {
                        if (item.id == $scope.guest.event_guest_accreditation_id) {
                            accreditation = item;
                        }
                    });

                    $scope.positionChecked = {

                        idx: item.event_person_order,
                        event_guest_id: item.id,
                        prefered_order: "",
                        checked: null,
                        confirmation_status: statusObject,
                        send_status: sendStatusObject,
                        is_companions_allowed: isCompanionsAllowedObject,
                        parking_id: $scope.guest.parking_id,
                        zone: $scope.guest.zone,
                        companions_zone: $scope.guest.companions_zone,
                        max_companions_allowed: $scope.guest.max_companions_allowed,
                        num_companions: $scope.guest.num_companions,
                        event_guest_accreditation_id: $scope.guest.event_guest_accreditation_id,
                        event_guest_accreditation: (accreditation !== undefined ? accreditation : {}),
                        send_invitation: $scope.guest.send_invitation,
                        allow_parking: $scope.guest.allow_parking,
                        max_vehicles_allowed: $scope.guest.max_vehicles_allowed,
                        num_vehicles: $scope.guest.num_vehicles,
                        custom_parking_config: $scope.guest.custom_parking_config,

                    };

                    $scope.event_allow_parking = event.allow_parking;
                    $scope.event_max_vehicles = event.allow_parking ? event.default_vehicle_limit : 0;

                    logService.debug($scope.event);

                    // Creamos variable para almacenar el estado previo de los acopmañantes 
                    let previousGuestInfo = $scope.positionChecked.is_companions_allowed;

                    if (!$scope.$$phase) $scope.$apply();

                    $scope.confirmation_status_value = statusObject.value;

                    Restangular.all('EventsParkings').getList({event_id: $stateParams.id}).then(function (parkings) {
                        $scope.selectParkings = parkings;
                        $scope.selectParkings.push({id: 0, name: $filter('translate')('events.guests.no_parking')})
                        if (!$scope.$$phase) $scope.$apply();
                    });

                    Restangular.all('EventsGuests/GetZoneOptions').getList({event_id: $stateParams.id}).then(function (results) {
                        $scope.selectZones = _.map(results, function (zone) {
                            return {id: zone, name: zone}
                        });
                        $scope.selectZones.push({id: null, name: $filter('translate')('events.guests.no_zone')})
                        if (!$scope.$$phase) $scope.$apply();
                    });

                    $scope.addNewParking = function () {
                        let $modalInstance = $uibModal.open({
                            animation: true,
                            template: AddNewParkingModalView,
                            controller: "addParkingModalCtrl",
                            size: 'lg',
                            resolve: {
                                options: {
                                    event_id: $stateParams.id
                                }
                            }
                        });

                        //Response del modal
                        $modalInstance.result.then(function (parking) {
                            Restangular.all('EventsParkings').post(parking).then(function (result) {
                                if (angular.isDefined(result.id)) {
                                    $scope.selectParkings.push(result);
                                    $scope.positionChecked.parking_id = result.id;
                                }
                            });

                            if (!$scope.$$phase) $scope.$apply();
                        });
                    }

                    $scope.addNewZone = function (type) {

                       let $modalInstance = $uibModal.open({
                            animation: true,
                            template: AddNewZoneModalView,
                            size: "lg",
                            controller: "addNewZoneModalCtrl",
                            resolve: {
                                options: {
                                    only_one: true
                                }
                            }
                       });

                        //Response del modal
                        $modalInstance.result.then(function (option) {
                            $scope.selectZones.push({id: option.name, name: option.name});
                            if (type == 'zone') {
                                $scope.positionChecked.zone = option.name;
                            } else if (type == 'companions_zone') {
                                $scope.positionChecked.companions_zone = option.name;
                            }

                            if (!$scope.$$phase) $scope.$apply();
                        });

                    }

                    if ($scope.guest != null) {

                        if (isDefinedAndNotNull($scope.guest.principalPhone)) $scope.showContactInfoPhone = true;
                        if (isDefinedAndNotNull($scope.guest.principalEmail)) $scope.showContactInfoEmail = true;

                        $scope.positionChecked.prefered_order = item.event_person_order;  //Siempre tienen una posición

                        // Seleccionar los cargos position_id
                        if (item.person_position_id != 0) {

                            // Esto lo mira desde la BD
                            angular.forEach($scope.guest.persons_positions, function (pp) {
                                if (pp.id == item.person_position_id) {
                                    pp.checked = true;
                                    $scope.positionChecked.checked = pp.id;
                                } else {
                                    pp.checked = false;
                                }
                            });
                        }

                    }

                    $scope.gridCompanion = {
                        enablePaginationControls: false,
                        paginationPageSize: 2,
                        paginationPageSizes: [2],
                        rowHeight: 45,
                        columnDefs: [
                            {name: 'id', visible: false, exporterSuppressExport: true},
                            {
                                name: 'name', displayName: 'Nombre',
                                cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{row.entity.name}}<br/> {{row.entity.position}}</div>',
                            },
                            {
                                name: ' ',
                                width: 100,
                                exporterSuppressExport: true,
                                enableSorting: false,
                                enableHiding: false,
                                enableFiltering: false,
                                enableColumnMenu: false,
                                cellTemplate: gridService.actionTemplate([
                                    {
                                        title: "Borrar",
                                        action: 'ng-click="grid.appScope.deleteCompanion(row.entity.id);"',
                                        cssIconClass: "fa fa-remove"
                                    }
                                ], {cssClass: "pull-right"})
                            },
                        ]
                    };

                    var rows_data = new Array();
                    if (isDefinedAndNotNullOrEmpty($scope.guest.persons1)) {

                        angular.forEach($scope.guest.persons1, function (row) {
                            rows_data.push({
                                id: row.id,
                                name: row.name + " " + (isDefinedAndNotNull(row.surname) ? row.surname : "") + " " + (isDefinedAndNotNull(row.lastname) ? row.lastname : ""),
                                position: isDefinedAndNotNull(row.position) ? row.position : ""
                            });
                        });

                        $scope.gridCompanion.data = rows_data;

                    } else {
                        $scope.gridCompanion.data = [];
                    }

                    checkCompanion($scope.positionChecked);

                    $scope.checkStatus = function (status) {

                        if (angular.isDefined(status)) {

                            // Sacamos el modal si tenemos  acompañantes nominativos y pasamos a un estado que no los permita. El booleano de acompañantes en eventos tiene el nombre mal puesto, cuando está puesto a true no los permite
                            /*

                                if (($scope.confirmation_status_value == "delegated" || $scope.gridCompanion.data.length > 0) && (status.is_companions_allowed.value == false || (status.is_companions_allowed.value == null && event.is_companions_allowed == true))) {

                                    modalService.confirm({
                                        title: $filter('translate')('events.guests.delete_delegated_title'),
                                        message: $filter('translate')('events.guests.delete_delegated') + "?",
                                        onAccept: function () {

                                            // Si aceptas actualizamos el último estado almacenado 
                                            previousGuestInfo = $scope.positionChecked.is_companions_allowed;

                                            Restangular.all('EventsGuests').customPOST({}, "DeleteRelatedGuests", {guest_id: status.event_guest_id}).then(function (result) {
                                                $scope.gridCompanion.data = [];
                                                $scope.saveGuestInfo();
                                            }, function (response) {
                                                logService.error("Error with status code", response.status);
                                            });
                                        },
                                        onCancel: function () {
                                            status.is_companions_allowed = previousGuestInfo;
                                        }
                                    })
                                }

                            */

                            if (status.num_companions > 0 || $scope.positionChecked.is_companions_allowed == false) {
                                modalService.confirm({
                                    title: $filter('translate')('events.guests.delete_delegated_title'),
                                    message: $filter('translate')('events.guests.delete_delegated') + "?",
                                    onAccept: function () {
                                        Restangular.all('EventsGuests').customPOST({}, "DeleteRelatedGuests", { guest_id: status.event_guest_id }).then(function (result) {
                                            $scope.gridCompanion.data = [];
                                            $scope.positionChecked.max_companions_allowed = 0;
                                            $scope.positionChecked.num_companions = 0;
                                            $scope.positionChecked.is_companions_allowed.value = null;
                                            $scope.companion = false;
                                            $scope.companionDelegateText = false;
                                            $scope.companionText = false;
                                            $scope.saveGuestInfo();
                                        }, function (response) {
                                            logService.error("Error with status code", response.status);
                                        });
                                    }
                                });

                            } else {
                                previousGuestInfo = $scope.positionChecked.is_companions_allowed;
                                $scope.confirmation_status_value = status.confirmation_status.value;
                                checkCompanion(status);
                                if ($scope.confirmation_status_value == "confirmed") {

                                    $scope.eventsConfirmableActs.forEach(function (act) {
                                        $scope.eventsProgramsActSelected[act.id] = "attend";
                                    });
                                    $scope.checkPartialAttendance();

                                } else {
                                    $scope.partial = $filter('translate')('events.guests.partial_attendance_uncheck');
                                    $scope.confirmationStatus[1].name = $filter('translate')('events.guests.confirmed') + ' ' + $scope.partial;
                                }

                            }
                        }
                    }

                    $scope.changeAccreditation = function (accreditation) {
                        $scope.positionChecked.event_guest_accreditation = accreditation;
                    }

                    $scope.addCompanion = function () {

                        let $modalInstance = $uibModal.open({
                            animation: true,
                            template: SearchGuestsModalView,
                            size: "lg",
                            controller: "SearchGuestsModalCtrl",
                            resolve: {
                                options: function () {
                                    return {
                                        companion: true,
                                        total: $scope.gridCompanion.data.length,
                                        limit: $scope.positionChecked.max_companions_allowed
                                    };
                                }
                            }
                        });

                        //Response del modal
                        $modalInstance.result.then(function (data) {
                            angular.forEach(data, function (item) {
                                $scope.gridCompanion.data.push(item); //añadimos los buscados
                            });
                            if (!$scope.$$phase) $scope.$apply();
                        }, function () {

                            console.info('Modal dismissed at: ' + new Date());

                            if (!$scope.$$phase) $scope.$apply();
                        });
                    };

                    $scope.createCompanion = function () {
                    
                            let $modalInstance = $uibModal.open({
                                animation: true,
                                template: AddGuestModalView,
                                size: "lg",
                                controller: "AddGuestModalCtrl",
                                scope: $scope,
                                resolve: {
                                    params: function () {
                                        return {
                                            event_id: event.id,
                                            referrer_person_id: $scope.guest.person_id,
                                            is_delegate: $scope.positionChecked.confirmation_status.value == 'delegated'
                                        }
                                    }
                                }
                            });

                            //Response del modal
                            $modalInstance.result.then(function (item) {
                                toastr.success($filter('translate')('events.guests.action_success'));
                               $scope.gridCompanion.data.push(item); //añadimos los buscados
                                if (!$scope.$$phase) $scope.$apply();
                                console.info('Modal dismissed at: ' + new Date());
                            }, function () {
                                console.info('Modal dismissed at: ' + new Date());
                                if (!$scope.$$phase) $scope.$apply();
                            });

                    }

                    $scope.deleteCompanion = function (id) {
                        angular.forEach($scope.gridCompanion.data, function (guest, idx) {
                            if (guest.id == id) {
                                $scope.gridCompanion.data.splice(idx, 1);
                            }
                        });
                    }

                });
            });

            var checkCompanion = function (guest) {
                if (guest.is_companions_allowed.value == null) {
                    if (!event.is_companions_allowed) {
                        $scope.positionChecked.max_companions_allowed = event.default_companions_limit;
                    } else {
                        $scope.positionChecked.max_companions_allowed = 0;
                    }
                } else if (guest.is_companions_allowed.value) {
                    if (guest.max_companions_allowed > 0) {
                        $scope.positionChecked.max_companions_allowed = guest.max_companions_allowed;
                    } else {
                        $scope.positionChecked.max_companions_allowed = 1;
                    }
                } 

                $scope.companionTexts.tab_title = $filter('translate')('events.guests.title_companions');

                if (guest.confirmation_status.value == 'delegated') {
                    
                    $scope.companionTexts.tab_title = $filter('translate')('events.guests.delegated_person');

                    $scope.positionChecked.max_companions_allowed = 1;
                    $scope.companion = true;
                    $scope.companionDelegateText = true;
                    $scope.companionText = false;

                } else if (guest.confirmation_status.value == 'confirmed' && (guest.is_companions_allowed.value || (guest.is_companions_allowed.value == null && !event.is_companions_allowed))) {

                    $scope.companion = true;
                    $scope.companionText = true;
                    $scope.companionDelegateText = false;

                } else {

                    $scope.companion = false;
                    $scope.companionDelegateText = false;
                    $scope.companionText = false;

                }

                $scope.showCompanionList = true;

            }

            $scope.modalSendMail = function (mail_to, all) {

                if (angular.isDefined(all)) {
                    var personIds = [];
                    angular.forEach($scope.filteredInvitedGuests, function (guest) {
                        if (angular.isDefined(guest.value) && guest.value != "") { //Sólo se envia email a los seleccionados.
                            personIds.push(guest.person_id);
                        }
                    });
                    var options = {
                        persons_ids: personIds
                    };
                    if (personIds.length > 0) {
                        /* Eliminado a la espera de saber a que direcciones de las del invitado se pretende enviar el eamil este... yo puedo
                         * dejarlo tal cual, mandarle el event_guests_ids y que sea lo que dios quiera, pero no sabrá el usuario si se ha enviao o no el email.
                         *var params = {
                             entity_type: "events",
                             entity_type_id: $stateParams.id,
                             event_guests_ids: guestsIds,
                             mail_account_id: event.mail_account_id,
                             mail_account_reply: event.reply_to,
                             documents: { for_event_guest: true }
                         };
                         notificationService.notificationMail({
                             params: params,
                             onAccept: function (data) {
                                 toastr.success($filter('translate')('notifications.sending_mail_success'));
                             }
                         });*/
                        /* $http({
                             method: 'get',
                             url: (window as any).CONFIG.api_url + 'EventsGuests/getEmailsFromGuests',
                             params: options
                         }).then(function (results, status, headers, config) {
                             mail_to = results.data.emails;
                             if (event.bcc == null) event.bcc = "";
                             if (mail_to != "") {
                                 modalService.mail({
                                     title: $filter('translate')('events.work_team.send_mail'),
                                     cco: mail_to + "," + event.bcc,
                                     module: "guests/email",
                                     code: $stateParams.id + "",
                                     onAccept: function () {
                                         toastr.success($filter('translate')('events.work_team.email_sent_success'));
                                         if (!results.data.success) {
                                             //No se ha podido enviar a todos los correos porque no existe uno público.
                                             modalService.message({
                                                 title: "Error",
                                                 message: results.data.message,
                                                 onAccept: function () { }
                                             });
                                         }
     
                                     },
                                     onCancel: function (response) {
                                         $scope.errorMessage = response.message;
                                     }
                                 });
                             } else {
                                 modalService.message({
                                     title: "Error",
                                     message: $filter('translate')('events.guests.send_mail_not_have_public_email_to'),
                                     onAccept: function () { }
                                 });
                             }
                         });*/
                    }
                } else {
                    /* modalService.mail({
                         title: $filter('translate')('events.work_team.send_mail'),
                         to: mail_to,
                         module: "guests/email",
                         code: $stateParams.id + "",$scope.positionChecked.max_vehicles_allowed
                         onAccept: function () {
                             toastr.success($filter('translate')('events.work_team.email_sent_success'));
                         },
                         onCancel: function (response) {
                             $scope.errorMessage = response.message;
                         }
                     });*/
                }
            }
            $scope.saveGuestInfo = function () {


                let error = "";

                // Validación de vehículos
                let allowParking = false;
                let max_vehicles_allowed = 0;

                // Si tiene configuración personalizada cogemos la del invitado
                if ($scope.positionChecked.custom_parking_config) {
                    allowParking = $scope.positionChecked.allow_parking;
                    max_vehicles_allowed = $scope.positionChecked.max_vehicles_allowed;
                } else { // Si no la del evento
                    allowParking = event.allow_parking;
                    max_vehicles_allowed = event.default_vehicle_limit;
                }

                if ($scope.positionChecked.custom_parking_config && $scope.positionChecked.allow_parking == true && $scope.positionChecked.max_vehicles_allowed < 1) {
                    error = $filter('translate')('events.min_vehicles_limit_exception_message');
                }

                if (allowParking && (max_vehicles_allowed < $scope.positionChecked.num_vehicles)) {
                    error = $filter('translate')('events.guests.max_vehicles_limit_exception_message');
                }

                // Si no permitimos parking cambiamos el número de vehículos a 0 
                if ($scope.positionChecked.allow_parking == false) {
                    $scope.positionChecked.max_vehicles_allowed = 0;
                }

                if ($scope.positionChecked.is_companions_allowed.value == true && $scope.positionChecked.max_companions_allowed < 1) {
                    error = $filter('translate')('events.min_companions_limit_exception_message');
                }

                // Validaciones de acompañantes.
                if ($scope.positionChecked.confirmation_status != "delegated" && ($scope.gridCompanion.data.length > $scope.positionChecked.num_companions || $scope.positionChecked.num_companions == 0)) $scope.positionChecked.num_companions = $scope.gridCompanion.data.length;
                if ($scope.positionChecked.max_companions_allowed < $scope.positionChecked.num_companions) {
                    error = "No se puede tener más acompañantes que los que se permite en el evento.";
                }

                // Seleccionamos los actos a los que invitado esta invitado.
                if (error !== "") {
                    modalService.message({
                        title: $filter('translate')('events.guests.title_modal_not_order'),
                        message: error,
                        onAccept: function () {
                        }
                    });
                } else {

                    // Si no permitimos acompañantes, asignamos el número de acompañantes a 0

                    if ($scope.positionChecked.is_companions_allowed.value == false) {
                        $scope.positionChecked.max_companions_allowed = 0;
                    }

                    let positionId: any = "";
                    if (isDefinedAndNotNullOrEmpty($scope.positionChecked.checked)) {
                        positionId = $scope.positionChecked.checked;
                    }

                    if (!isDefinedAndNotNullOrEmpty($scope.positionChecked.prefered_order)) {
                        modalService.message({
                            title: $filter('translate')('events.guests.title_modal_not_order'),
                            message: $filter('translate')('events.guests.message_modal_not_order'),
                            onAccept: function () {
                            }
                        });
                    } else {
                        var row = $scope.gridCompanion.data;
                        var ids = new Array();
                        angular.forEach(row, function (row) {
                            ids.push(row.id);
                        });

                        var totalNumCompanions = 0;
                        if ($scope.gridCompanion.data.length > 0 && Number($scope.positionChecked.num_companions) == $scope.gridCompanion.data.length) {
                            totalNumCompanions = $scope.positionChecked.num_companions;
                        } else {
                            if ($scope.positionChecked.num_companions == 0) {
                                totalNumCompanions = $scope.gridCompanion.data.length;
                            } else {
                                totalNumCompanions = $scope.positionChecked.num_companions;
                            }
                        }

                        $scope.checkPartialAttendance();

                        var options = {
                            event_id: event.id,
                            eventGuestsNewOrder: $scope.positionChecked.prefered_order,
                            event_guest_id: $scope.positionChecked.event_guest_id,
                            status: $scope.positionChecked.confirmation_status.value,
                            person_position_id: positionId,
                            eventGuestsReferred: ids,
                            send_status: $scope.positionChecked.send_status.value,
                            is_companions_allowed: $scope.positionChecked.is_companions_allowed.value,
                            parking: $scope.positionChecked.parking,
                            parking_id: $scope.positionChecked.parking_id,
                            zone: $scope.positionChecked.zone,
                            companions_zone: $scope.positionChecked.companions_zone,
                            max_companions_allowed: $scope.positionChecked.max_companions_allowed,
                            num_companions: totalNumCompanions,
                            event_guest_accreditation_id: (angular.isDefined($scope.positionChecked.event_guest_accreditation) && $scope.positionChecked.event_guest_accreditation != null ? $scope.positionChecked.event_guest_accreditation.id : null),
                            send_invitation: $scope.positionChecked.send_invitation,
                            partial_attendance: $scope.guest.partial_attendance,
                            allow_parking: $scope.positionChecked.allow_parking,
                            max_vehicles_allowed: $scope.positionChecked.max_vehicles_allowed,
                            custom_parking_config: $scope.positionChecked.custom_parking_config,
                        };

                        // Comprobamos si va a asisitir solo a algunos actos para asignale una confirmación parcial
                        $http({
                            method: 'get',
                            url: (window as any).CONFIG.api_url + 'EventsGuests/SaveEventGuest',
                            params: options
                        }).then(function (results, status, headers, config) {
                            let event_acts_ids = [];
                            let event_acts_show_ids = [];
                            angular.forEach($scope.eventsProgramsActSelected, function (item, idx) {
                                if (item == "attend") event_acts_ids.push(idx);
                                if (item == "show") event_acts_show_ids.push(idx);
                            });

                            // if (event_acts_ids.length > 0 || event_acts_show_ids.length > 0) {
                            var epag = {
                                event_acts_ids: event_acts_ids,
                                event_acts_show_ids: event_acts_show_ids, 
                                guest_id: item.id,
                                event_id: event.id
                            }

                            // Guardamos los actos

                            $http({

                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'EventsGuests/SetActsGuest',
                                data: epag,

                            }).then(function (resultsImage, status, headers, config) {

                            });

                            //}

                            let events_annexes_ids = [];

                            angular.forEach($scope.eventsAnnexesSelected, function (item, idx) {
                                if (item == "checked") {
                                    events_annexes_ids.push(idx);
                                }
                            });

                            var annexes = {
                                event_guest_id: item.id,
                                event_id: event.id,
                                events_annexes_ids: events_annexes_ids
                            }

                            // Guardamos los tipos de documentos
                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'EventsGuests/SetAnnexesGuest',
                                data: annexes,
                            }).then(function (resultsImage, status, headers, config) {

                            });

                            var programActs = [];

                            angular.forEach($scope.eventsProgramsActs, function (programAct) {
                                var menus = [];
                                if (programAct.FK_events_programs_acts_menus_events_programs_acts.selected != null) {
                                    menus.push(programAct.id);
                                    menus.push(programAct.FK_events_programs_acts_menus_events_programs_acts.selected.id);
                                    menus.push(item.id);
                                    var isPrincipal = (programAct.FK_events_programs_acts_menus_events_programs_acts.selected.is_principal ? 1 : 0);
                                    menus.push(isPrincipal)
                                    programActs.push(menus);
                                }
                            });


                            $http({
                                method: 'post',
                                url: (window as any).CONFIG.api_url + 'EventsProgramsActs/SaveConfigMenus',
                                params: {event_id: event.id},
                                data: programActs
                            }).then(function (results, status, headers, config) {
                                $uibModalInstance.dismiss('cancel');
                            });

                            // Guardamos las notas.

                            Restangular.all("EventsGuestsNotes").customPOST($scope.gridOptionsGuestsNotes.data, "SaveGuestNotes", {event_guest_id: $scope.positionChecked.event_guest_id}).then(function (results) {
                            });

                            
                            $uibModalInstance.close(); //cerramos la ventanica

                          
                        });
                    }
                }
            };

            $scope.onCancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.gridOptionsGuestsNotes = {
                pdfTitle: $filter('translate')('events.guests.guests_notes'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                enableSorting: true,
                paginationPageSizes: [5, 15, 30],
                paginationPageSize: 5,
                rowTemplate: '<div ng-dblclick="grid.appScope.addEventGuestNotes(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    {name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true},
                    {
                        name: 'created_at',
                        displayName: $filter('translate')('events.guests.created_at'),
                        maxWidth: 125,
                        minWidth: 80,
                        type: 'date',
                        cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                        customFormatFn: function (value) {
                            if (value != null) {
                                var fecha = new Date(value);
                                return $filter('date')(fecha, 'dd/MM/yyyy');
                            }
                            return "";
                        },
                        enableFiltering: false,
                        enableColumnMenu: false
                    },
                    {
                        name: 'name_created',
                        displayName: $filter('translate')('events.guests.name_created_note'),
                        visible: true,
                        enableHiding: false,
                        exporterSuppressExport: false,
                        enableFiltering: false
                    },
                    {
                        name: 'notes',
                        displayName: $filter('translate')('events.guests.guests_notes'),
                        enableFiltering: false,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.notes" popover-append-to-body="true">{{row.entity.notes}}</a></div>',
                    },
                    {
                        name: ' ',
                        width: 200,
                        exporterSuppressExport: true,
                        enableSorting: false,
                        enableHiding: false,
                        enableFiltering: false,
                        enableColumnMenu: false,
                        cellTemplate: gridService.actionTemplate([
                            {
                                title: $filter('translate')('events.button_edit'),
                                action: 'ng-click="grid.appScope.addEventGuestNotes(row.entity)"',
                                cssIconClass: "fa fa-edit"
                            },
                            {
                                title: $filter('translate')('events.button_delete'),
                                action: 'ng-click="grid.appScope.deleteEventGuestNotes(row.entity);" ',
                                cssIconClass: "fa fa-remove"
                            }
                        ], {cssClass: "pull-right"})
                    },
                ],
                getData: function (options) {

                    var deferred = $q.defer();
                    options.event_guest_id = item.id;
                    Restangular.all('EventsGuestsNotes').getList(options).then(function (result) {
                        var data = result;
                        data.totalRows = result.totalRows;
                        $scope.totalRows = result.totalRows;
                        deferred.resolve(data);
                    })
                    return deferred.promise;

                }
            };

            $scope.addEventGuestNotes = function (egnotes) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: GuestNotesModalView,
                    controller: "GuestNotesModalCtrl",
                    size: 'md',
                    resolve: {
                        event_guest_notes: function () {
                            return egnotes
                        },
                        event_guest_id: function () {
                            return item.id;
                        }
                    }
                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {

                    if ((angular.isUndefined(resultModal.id) || resultModal.id == null) && resultModal.is_new) $scope.gridOptionsGuestsNotes.data.push(resultModal);
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
            };

            //Delete menu desde el listado
            $scope.deleteEventGuestNotes = function (egnotes) {
                modalService.confirm({
                    title: $filter('translate')('events.guests.button_delete_notes_title'),
                    message: $filter('translate')('events.guests.delete_message_notes_message') + "?",
                    onAccept: function () {
                        $scope.gridOptionsGuestsNotes.data.splice($scope.gridOptionsGuestsNotes.data.indexOf(egnotes), 1);
                    }
                });
            };

            $scope.gridOptionNotifications = {
                pdfTitle: $filter('translate')('notifications.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                enableFiltering: false,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    {name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true},
                    {
                        name: 'subject',
                        displayName: $filter('translate')('notifications.subject'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.FK_notifications_to_notifications_emails.subject }}</div>',
                    },
                    {
                        name: 'date',
                        displayName: $filter('translate')('notifications.date'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.FK_notifications_to_notifications_emails.date | toLocalDate | date: "dd/MM/yyyy HH:mm" }}</div>',
                    },
                    {
                        name: 'email',
                        displayName: $filter('translate')('notifications.email'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.mails }}</div>',
                    },
                    {
                        name: 'state',
                        displayName: $filter('translate')('notifications.state'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: left;\">" +
                            "<span ng-if=\"row.entity.state=='error'\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "<span ng-if=\"row.entity.state=='sent'\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                            "</div>",
                    },
                    {
                        name: ' ',
                        width: 150,
                        exporterSuppressExport: true,
                        enableSorting: false,
                        enableHiding: false,
                        enableFiltering: false,
                        enableColumnMenu: false,
                        cellTemplate: gridService.actionTemplate([
                            {
                                title: $filter('translate')('notifications.button_view'),
                                action: 'ng-click="grid.appScope.goToEditNotification(row.entity)"',
                                cssIconClass: "fa fa-eye"
                            },
                        ], {cssClass: "pull-right"})
                    },
                ],
                getData: function (options) {
                    return Restangular.all('EventsGuests/' + item.id + '/notifications').getList();
                }
            };

            $scope.goToEditNotification = function (rowEntity) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: NotificationsModalMailInfoView,
                    controller: 'NotificationsToInfoCtrl',
                    size: 'lg',
                    resolve: {
                        id: function () { return rowEntity.id; }
                    }
                })

                $modalInstance.result.then(function (bool) {
                    $scope.cancel();
                });

            };

            /*$scope.goToEditNotification = function (rowEntity) {
                $uibModalInstance.dismiss('cancel');
                $state.go("notifications.edit", {notificationId: rowEntity.notification_email_id});
            };*/

            $scope.gridOptionsGuestsZones = {
                pdfTitle: $filter('translate')('spaces.title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                enableFiltering: false,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    {name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true},
                    {
                        name: 'space',
                        displayName: $filter('translate')('events.guests.space'),
                        minWidth: 400,
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.FK_events_guests_zones_events_spaces_zones.FK_events_spaces_zones_events_spaces.name }}</div>',
                    },
                    {
                        name: 'zone',
                        displayName: $filter('translate')('events.guests.zone'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.FK_events_guests_zones_events_spaces_zones.name }}</div>',
                    },
                    {
                        name: 'prefered_position',
                        width: 100,
                        displayName: $filter('translate')('events.guests.prefered_position'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.prefered_position }}</div>',
                    },
                    {
                        name: 'row',
                        width: 100,

                        displayName: $filter('translate')('events.guests.row'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.file }}</div>',
                    },
                    {
                        name: 'seat',
                        width: 100,

                        displayName: $filter('translate')('events.guests.seat'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                        cellTemplate: '<div class="ui-grid-cell-contents ng-binding ng-scope">{{ row.entity.position }}</div>',
                    },
                    {
                        name: ' ',
                        width: 200,
                        exporterSuppressExport: true,
                        enableSorting: false,
                        enableHiding: false,
                        enableFiltering: false,
                        enableColumnMenu: false,
                        cellTemplate: gridService.actionTemplate([
                            {
                                title: $filter('translate')('events.button_edit'),
                                action: 'ng-click="grid.appScope.addEventGuestSpaceZone(row.entity)"',
                                cssIconClass: "fa fa-edit"
                            },
                            {
                                title: $filter('translate')('events.button_delete'),
                                action: 'ng-click="grid.appScope.deleteEventGuestSpaceZone(row.entity);" ',
                                cssIconClass: "fa fa-remove"
                            }
                        ], {cssClass: "pull-right"})
                    },
                ],
                getData: function (options) {
                    return Restangular.all('EventsSpaceGuests/' + item.id + '/zones').getList();
                }
            };
            
            $scope.deleteEventGuestSpaceZone = function (egzone) {
                modalService.confirm({
                    title: $filter('translate')('events.guests.delete_event_guest_space_zone_title'),
                    message: $filter('translate')('events.guests.delete_event_guest_space_zone_message'),
                    onAccept: function () {
                        $scope.gridOptionsGuestsZones.data.splice($scope.gridOptionsGuestsZones.data.indexOf(egzone), 1);
                        Restangular.one('EventsSpaceGuests/' + item.id + '/zones', egzone.id).remove().then(function (result) {
                        });
                    }
                });
            };

            $scope.addEventGuestSpaceZone = async function (egzone) {

                let spaceAssignedIds = $scope.gridOptionsGuestsZones.data
                    .map(space => space.FK_events_guests_zones_events_spaces_zones.event_space_id);

                let spaces = await eventService.getSpaces(event.id);

                // logService.debug(spaces);
                // Deshabilitamos los espacios que ya tiene asignados el invitado
                spaces.forEach(function(space) {
                    if (spaceAssignedIds.includes(space.id)) space.disabled = true;
               });

                logService.debug(spaces);

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: GuestSpaceZonesModalView,
                    controller: "GuestSpaceZonesModalCtrl",
                    size: 'md',
                    resolve: {
                        event_guest_zone: function () {
                            return egzone
                        },
                        event_guest_id: function () {
                            return item.id;
                        },
                        spaces: function () {
                            return spaces;
                        }
                    }
                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {

                    if ((angular.isUndefined(resultModal.id) || resultModal.id == null) && resultModal.is_new) {
                        
                        let eventGuestZone = eventService.addEventGuestSpaceZone(event.id, resultModal.spaceSelected.id,
                            resultModal.event_guest_zone.id, item.id).$object;

                        $scope.gridOptionsGuestsZones.data.push(eventGuestZone);

                    } else {

                        let eventGuestZone = eventService.modifyEventGuestSpaceZone(event.id, resultModal.spaceSelected.id,
                            resultModal.event_guest_zone.id, item.id).$object;
                        $scope.gridOptionsGuestsZones.data.splice($scope.gridOptionsGuestsZones.data.indexOf(egzone), 1);

                        $scope.gridOptionsGuestsZones.data.push(eventGuestZone);

                    }

                    // if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
            };

            $scope.gridOptionVehicles = {
                pdfTitle: $filter('translate')('vehicles.pdf_title'),
                exporterMenuCsv: true,
                enableGridMenu: true,
                gridMenuShowHideColumns: false,
                paginationPageSizes: [10, 20, 30],
                paginationPageSize: 10,
                enableFiltering: false,
                rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
                onRegisterApi: function (gridApi) {
                    this.gridApi = gridApi;
                },
                columnDefs: [
                    {name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true},
                    {
                        name: 'car_manufacturer',
                        displayName: $filter('translate')('events.guests.guest_vehicle_manufacturer'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                    },
                    {
                        name: 'car_model',
                        displayName: $filter('translate')('events.guests.guest_vehicle_model'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                    },
                    {
                        name: 'car_color',
                        displayName: $filter('translate')('events.guests.guest_vehicle_color'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                    },
                    {
                        name: 'car_plate',
                        displayName: $filter('translate')('events.guests.guest_vehicle_plate'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                    },
                    {
                        name: 'driver_name',
                        displayName: $filter('translate')('events.guests.guest_vehicle_driver_name'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                    },
                    {
                        name: 'driver_identification_number',
                        displayName: $filter('translate')('events.guests.guest_vehicle_driver_identification'),
                        enableFiltering: true,
                        enableHiding: false,
                        enableColumnMenu: false,
                    },
                    {
                        name: ' ',
                        width: 150,
                        exporterSuppressExport: true,
                        enableSorting: false,
                        enableHiding: false,
                        enableFiltering: false,
                        enableColumnMenu: false,
                        cellTemplate: gridService.actionTemplate([
                            {
                                title: $filter('translate')('general.button_edit'),
                                action: 'ng-click="grid.appScope.addEventGuestVehicle(row.entity, true)"; ng-if="grid.appScope.allowWrite"',
                                cssIconClass: "fa fa-edit"
                            },
                            {
                                title: $filter('translate')('general.button_delete'),
                                action: 'ng-click="grid.appScope.deleteEventGuestVehicle(row.entity);" ng-if="grid.appScope.allowWrite"',
                                cssIconClass: "fa fa-remove"
                            }
                        ], {cssClass: "pull-right"})
                    },
                ],
                getData: function (options) {

                    return Restangular.all('EventsGuestsVehicles').getList({event_guest_id: item.id}); // TODO
                }
            };

            $scope.deleteEventGuestVehicle = function (egVehicle) {

                modalService.confirm({
                    title: $filter('translate')('events.guests.guest_vehicle_delete'),
                    message: $filter('translate')('events.guests.guest_vehicle_delete_message'),
                    onAccept: function () {
                    // Lo sacamos del grid
                    egVehicle.remove().then(function (result) {
                        $scope.gridOptionVehicles.loadData(false);
                        // No sé si hacerlo así
                        $scope.positionChecked.num_vehicles = result;
                    })

                    }, function(response) {
                        alert("Error al borrar")
                    }
                });
            }
            $scope.addEventGuestVehicle = function (egVehicle, is_edit = false) {


                let limitVehicles = $scope.positionChecked.custom_parking_config ? $scope.positionChecked.max_vehicles_allowed : event.default_vehicle_limit;

                logService.debug(`$scope.positionChecked.num_vehicles = ${limitVehicles} && $scope.positionChecked.max_vehicles_allowed = ${limitVehicles}`);

                // Comprobamos si hemos llegado al límite
                if ($scope.positionChecked.num_vehicles >= limitVehicles && !is_edit) {

                    return modalService.message({
                        title: $filter('translate')('events.guests.max_vehicles_reached'), //"Acción no compatible con todos los elementos",
                        message: $filter('translate')('events.guests.max_vehicles_reached_message'), //"Esta acción requiere que el invitado tenga una coincidencia en la aplicación. Solo se ha aplicado a los invitados pertinentes.",//$filter('translate')('events.image_size_limit') + "<br>" + limit_image_width + "X" + limit_image_height,
                        onAccept: function () { }
                    });

                };

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: GuestVehiclesModalView,
                    controller: "GuestVehiclesModalCtrl",
                    size: 'md',
                    resolve: {
                        event_guest_vehicle: function () {
                            return egVehicle
                        },
                        event_guest_id: function () {
                            return item.id;
                        }
                    }
                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {

                    logService.debug('resultModal :' + resultModal)
                    $scope.gridOptionVehicles.loadData(false);
                    $scope.positionChecked.num_vehicles = resultModal;
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    });
                }

        }])

    .controller("AssignIdentifierModalCtrl", ['$scope', '$uibModalInstance', 'event_guest', 'Restangular', '$http', 'modalService', '$filter', '$rootScope', function ($scope, $uibModalInstance, event_guest, Restangular, $http, modalService, $filter, $rootScope) {
        //Comprobamos si tiene permiso escritura

        $scope.event_guest = event_guest;
        if (event_guest.FK_events_guests_identifiers != null) $scope.event_guest.identifier = event_guest.FK_events_guests_identifiers.value;
        //$scope.event_guest.identifier = "";

        Restangular.all("IdentifiersTypes").getList().then(function (identifiers_types) {
            $scope.identifiers_types = identifiers_types;
            $scope.event_guest.identifier_type = identifiers_types[0];
        });

        $scope.keyPressed = function (keyEvent) {
            if (keyEvent.which === 13)
                $scope.saveIdentifier($scope.event_guest.identifier);
        }
        $scope.saveIdentifier = function (identifier) {

            let data = {
                value: identifier,
                identifier_type_id: $scope.event_guest.identifier_type.id,
                forceSaved: false,
                person_id: $scope.event_guest.person_id,
                event_id: $scope.event_guest.event_id
            }

            $uibModalInstance.close(data);

        };
        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }]);
